<template>
  <div class="darkBg flex content-start-alt" v-if="brand_id !== null">

    <sweet-modal ref="test" icon="warning" title="Forgot Something?">
      {{ modalErrorMessage }}
    </sweet-modal>
    <div class="whiteBg">
      <!-- header section -->
      <div class="inactiveTitle" v-if="!checkout.form && !checkout.formType.mainForm">
        <template v-if="step === 0">
          <span class="normalText" style="margin-left:20px"> <img v-if="brand.logo" width="65px" style="position:relative;top:3px;" :src="brand.logo" :alt="brand.name"/> {{ brand.name }}</span>
        </template>
        <template v-if="step === 1">

          <span v-if="currentSelectedMenu.selected === true" @click="backToMenuList()" class="normalText hover" style="margin-left:20px"> <i class="fa fa-chevron-left"></i> Menu </span>
          <span v-else-if="checkout.formType.guestCheckout === true" @click="backToMenuList()" class="normalText hover" style="margin-left:20px"> <i class="fa fa-chevron-left"></i> Menu </span>
          <template v-else>
            <template v-if="checkout.formType.logoutForm">
              <span  @click="reset()" class="normalText hover" style="margin-left:20px"> <i class="fa fa-chevron-left"></i> Back </span>
            </template>
            <span v-else @click="backToLocations" class="normalText hover" style="margin-left:20px"> <i class="fa fa-chevron-left"></i> Locations </span>
          </template>
          <span class="mobile-cart">
            <a href="#" v-on:click.prevent="cartItemToggle = true"><i class="fa fa-shopping-cart" aria-hidden="true"></i> </a> ${{ total || '$0.00' }}
          </span>
        </template>
        <!-- NOTE: hide login for now
        <template v-if="user.loggedIn">
        <a v-on:click="displayLogoutForm()" class="accent" style="float:right;">
        <i class="fa fa-user-circle"></i>
        {{ user.detail.first_name }}
      </a>
    </template>
    <template v-else>
    <a  v-on:click="displayLoginForm()" class="accent" style="float:right;">
    <i class="fa fa-user-circle"></i>
    Log In
  </a>
</template>
-->
      </div>

      <template v-if="step === 0">

        <!-- locations -->
        <div v-on:click="editSection('locations')" :class="[singleLocation ? 'null-event' : '', locations.active ? 'is-active flex-center content-start hover accordion__pane-header' : 'flex-center content-start hover accordion__pane-header']">
    <span class="flex-center tab-heading-icon">
      <i class="fa" :class="locations.icon"></i>
    </span>
          <i class="fa fa-pencil" v-show="!singleLocation" aria-hidden="true" style="position:absolute;left:500px"></i>
          <template v-if="!locations.selected">
            Choose {{ locations.name }}
          </template>
          <template v-else>
            {{ locations.selected.display_name }}
          </template>
        </div>
        <div v-if="locations.active" class="animate animated fadeIn sectionBody item-start flex-column show-scroller">
          <div class="loader" v-if="locations.data.length < 1">Loading...</div>
          <div @click="selectSection('location', item)" v-for="item in locations.data" :key="item.id" class="content-center item-start flex-column activeBody hover select">
            <div style="font-size:18px;" class="accent"> {{ item.display_name }} </div>
            <div style="font-size:14px;"> {{ item.address_line_2 }} {{ item.address_line_1 }} {{ item.province }} {{ item.city }}</div>
          </div>
        </div>


        <!-- Time -->
        <div v-on:click="editSection('time')" :class="[!isEnablePickupLater ? 'null-event' : '', chooseTime.active ? 'is-active flex-center content-start hover accordion__pane-header' : 'flex-center content-start hover accordion__pane-header']">
    <span class="flex-center tab-heading-icon">
      <i class="fa" :class="chooseTime.icon"></i>
    </span>
          <i class="fa fa-pencil" v-show="isEnablePickupLater" aria-hidden="true" style="position:absolute;left:500px"></i>
          <template v-if="!chooseTime.selected">
            Choose {{ chooseTime.name }}
          </template>
          <template v-else>
            {{ chooseTime.selected.title }}
          </template>
        </div>
        <div v-if="chooseTime.active" class="animate animated fadeIn sectionBody item-start flex-column relative show-scroller">
          <div class="loader" v-if="chooseTime.data.length < 1">Loading...</div>
          <div @click="selectSection('time', item)" v-for="item in chooseTime.data" :key="item.id">
            <template v-if="item.identifier == 'now'">
              <div class=" content-center item-start flex-column activeBody hover select">
                <template v-if="locations.selected.current_online_ordering_status && locations.selected.online_ordering">
                  <div style="font-size:18px;" class="accent"> {{ item.title }} </div>
                  <div style="font-size:14px;"> {{ item.desc }}</div>
                </template>
                <template v-else>
                  <div style="font-size:18px;" class="accent">Order for now (unavailable) </div>
                  <div style="font-size:14px;">Order for Now is not available at this time. Click here to see hours.</div>
                </template>
              </div>
            </template>

            <template v-else>
              <template v-if="locations.selected.location_profile.enable_pickup_later">
                <div class=" content-center item-start flex-column activeBody hover select">
                  <div style="font-size:18px;" class="accent"> {{ item.title }} </div>
                  <div style="font-size:14px;"> {{ item.desc }}</div>
                </div>
              </template>
            </template>
          </div>

          <div class="order-later" v-if="chooseTime.orderLater.active">
            <div class="order-later-header">
              <h4>Choose a Date & Time  <a href="#" v-on:click.prevent="chooseTime.orderLater.active = false">< Back</a></h4>
              <ul v-if="chooseTime.orderLater.days">
                <li v-if="locations.selected.location_hours[day.indexofWeek].open === 1" v-on:click="selectOrderLaterDay(key, day)" v-for="(day, key) in chooseTime.orderLater.days" :class="day.selected ? 'active' : ''"> {{ day.day }}<span>{{ day.date }}</span></li>
              </ul>
            </div>
            <div class="order-later-content">

              <p class="note" v-if="chooseTime.orderLater.availableHours.length < 1">Pick a day to see available times.</p>
              <ul v-else>
                <!-- TODO: iff selectedDate today: else every future date hour -->

                <li v-if="key > 0 && (isHalfHourLater(item.global_hour))" v-for="(item, key) in chooseTime.orderLater.availableHours" :class="item.focus ? 'active': ''">
                  <template v-if="item.focus">
                    <a href="#" v-on:click.prevent="selectOrderLaterHour(item)" class="focused-time'">
                      <strong> Confirm</strong>  {{ item.hour }}:{{ item.min }} {{ item.ampm }}
                    </a>
                  </template>
                  <template v-else>
                    <p v-on:click="focusOrderLaterHour(key)">
                      {{ item.hour }}:{{ item.min }} {{ item.ampm }}
                    </p>
                  </template>
                </li>
              </ul>
            </div>
          </div>

        </div>

        <!-- Methods -->
        <div v-on:click="editSection('method')" :class="[!locations.delivery_status ? 'null-event' : '' , chooseMethods.active ? 'is-active flex-center content-start hover accordion__pane-header' : 'flex-center content-start hover accordion__pane-header']">
    <span class="flex-center tab-heading-icon">
      <i class="fa" :class="chooseMethods.icon"></i>
    </span>
          <i class="fa fa-pencil" v-if="locations.delivery_status" aria-hidden="true" style="position:absolute;left:500px"></i>
          <template v-if="!chooseMethods.selected">
            Choose {{ chooseMethods.name }}
          </template>
          <template v-else>
            {{ chooseMethods.selected.title }}
          </template>
        </div>
        <div v-if="chooseMethods.active" class="animate animated fadeIn sectionBody item-start flex-column show-scroller">
          <div class="loader" v-if="chooseMethods.data.length < 1">Loading...</div>

          <div @click="selectSection('method', item)" v-for="item in chooseMethods.data" :key="item.id">

            <template v-if="item.title == 'Pickup'">
              <div class="content-center item-start flex-column activeBody hover select">
                <div style="font-size:18px;" class="accent"> {{ item.title }} </div>
                <div style="font-size:14px;"> {{ item.desc }}</div>
              </div>
            </template>

            <template v-if="item.title == 'Delivery'">
              <template v-if="locations.delivery_status">
                <div class="content-center item-start flex-column activeBody hover select">
                  <div style="font-size:18px;" class="accent"> {{ item.title }} </div>
                  <div style="font-size:14px;"> {{ item.desc }}</div>
                </div>
              </template>
            </template>

          </div>
        </div>

        <div style="margin-top: 20px" class="pad-10" v-if="menuItems.active">
          <el-button v-on:click="setStepOne()" type="primary" style="width:100%;border-radius: 0;font-size:24px;">
            Confirm and View Menu
          </el-button>
        </div>
      </template>

      <template v-else-if="step === 1">

        <div class="pad-20 menu-items-wrapper" style="margin-top:10px !important; padding-top:0 !important;">
          <!-- if checkout is false -->
          <div v-show="checkout.form == false">
            <section style="padding-bottom:150px;" v-show="currentSelectedMenu.selected === false">

              <div v-if="menuItems.data.length < 1 " class="flex-center inactiveTitle">
                No menu for this location
              </div>
              <div  v-for="(section, key) in menuItems.data" :key="section.id" v-if="section.status != 0 " class="menu-category-list">
                <div :class="key == 0 ? 'open main-cat-list' : 'main-cat-list'" v-if="section.categories.length > 0">
                  <h4>{{ section.name }} <i class="fa fa-chevron-right"></i></h4>
                </div>

                <!-- if has category -->
                <template v-if="section.categories.length > 0" >
                  <ul :class="key == 0 ? 'sub-cat-ul open' : 'sub-cat-ul hide'">
                    <li v-for="item in section.categories"  :key="item.id" v-if="item.status !=0">
                      <div class="sub-cat-list pointer">
                        {{ item.name }} <i class="fa fa-chevron-right"></i>
                      </div>

                      <!-- if blank sub category -->
                      <template v-if="item.subcategories.length > 0">
                        <ul class="sub-sub-cat-ul" style="display:none">
                          <li v-for="subitem in item.subcategories" v-if="subitem.status!=0" >
                            <div class="sub-sub-cat-list pointer">
                              {{ subitem.name }} <i class="fa fa-chevron-right"></i>
                            </div>
                            <ul v-if="subitem.items" class="sub-sub-sub-cat-ul" style="display:none">
                              <li v-for="subitem in subitem.items" v-if="subitem.status!=0">
                                <a href="" v-on:click.prevent="showmMenuItemDetail(subitem)">
                                  {{subitem.name}}
                                  <span class="subitem-price"> &dollar;{{ subitem.price}}</span>
                                  <!-- <br/>
                            <small v-if="subitem.desc.toLowerCase() !== subitem.name.toLowerCase()"> {{ subitem.desc }}  </small> -->
                                </a>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </template>

                      <template v-else>
                        <ul v-if="item.items" class="sub-sub-cat-ul" style="display:none">
                          <li v-for="subitem in item.items" v-if="subitem.status!=0">
                            <a href="" v-on:click.prevent="showmMenuItemDetail(subitem)">
                              {{ subitem.name }}
                              <span class="subitem-price"> &dollar;{{ subitem.price}}</span>
                            </a>
                          </li>
                        </ul>
                      </template>
                    </li>
                  </ul>

                </template>
              </div>
            </section>
          </div>

          <div v-if="checkout.form == true">
            <section class="checkout-login-form-wrapper">
              <!-- main login form -->
              <div :class="checkout.formType.mainForm ? 'main-loginform visible' : 'main-loginform invisible'">
                <!-- <h2>Login</h2> -->
                <img v-if="brand.logo" width="120px" style="position:relative;top:3px;margin-top:30px" :src="brand.logo" :alt="brand.name"/> <br/>

                <!-- <button class="login-with-gmail">
          <i class="fa fa-google" aria-hidden="true"></i> <span>Login with Google</span>
        </button>
        <p>or</p> -->
                <div class="checkout-login-form">
                  <p id="alert-register" v-if="loginForm.error.status" :class="loginForm.error.status == 'ok' ? 'alert alert-success' : 'alert alert-warning'">{{ loginForm.error.message }}</p>
                  <input type="email" v-model="loginForm.user_name" name="email" placeholder="E-mail"/>
                  <input type="password" v-model="loginForm.password"  name="password" placeholder="Password"/>
                  <button class="submit-login" v-on:click="login(loginForm)"> Login</button>
                  <div class="checkout-form-attrs">
                    <a class="checkout-form-cancel" v-on:click.prevent="backFromCheckout()" href="#">Cancel</a>
                    <a href="" class="create-account" v-on:click.prevent="createAnAccount()"><i class="fa fa-user-o" aria-hidden="true"></i> Create an Account</a>
                    <a class="checkout-form-forgot-pass" v-on:click.prevent="displayForgotPasswordForm()" href="#">Forgot Password?</a>
                  </div>
                </div>
                <!--    <div class="guest-checkout-wrapper create-an-account-wrapper">

      </div> -->
                <div style="width: 100%; height: 20px; border-bottom: 1px solid black; text-align: center">
        <span style="font-size: 20px; background-color: #fff; padding: 0 10px;">
          OR
        </span>
                </div>
                <div class="guest-checkout-wrapper">
                  <a href="" v-on:click.prevent="guestCheckout()">Continue Guest Checkout &nbsp;   &nbsp;<i class="fa fa-arrow-circle-right" aria-hidden="true"></i></a>
                </div>
                <img width="100px" style="margin-top:40px;" src="../assets/powered.png" alt=""/>
              </div>


              <div :class="checkout.formType.logoutForm ? 'main-loginform visible' : 'main-loginform invisible'">
                <h2>Logout</h2>
                <div class="guest-checkout-wrapper">
                  <a href="" v-on:click.prevent="logout()">Logout</a>
                </div>
              </div>

              <!--  registration form -->
              <div :class="checkout.formType.registerForm ? 'registration-wrapper visible' : 'registration-wrapper invisible'">
                <h2>Create an Account</h2>
                <div class="checkout-login-form">
                  <p id="alert-register" v-if="createAccountForm.error.status" :class="createAccountForm.error.status == 'ok' ? 'alert alert-success' : 'alert alert-warning'">{{ createAccountForm.error.message }}</p>
                  <p><input type="text" name="first_name" v-model="createAccountForm.first_name" placeholder="First Name"/></p>
                  <p><input type="text" name="last_name" v-model="createAccountForm.last_name" placeholder="Last name"/></p>
                  <p><input type="email" name="last_name" v-model="createAccountForm.email" placeholder="Email"/></p>
                  <p><input type="phone" name="phone" v-model="createAccountForm.phone" placeholder="Phone"/></p>
                  <p><input type="text" name="address1" v-model="createAccountForm.address" placeholder="Address1"/></p>
                  <p><input type="text" name="address2" v-model="createAccountForm.address2" placeholder="Address2"/></p>
                  <p><input type="text" name="city" v-model="createAccountForm.city" placeholder="City"/></p>
                  <p><input type="text" name="province" v-model="createAccountForm.province" placeholder="Province"/></p>
                  <p><input type="text" name="postal_code" v-model="createAccountForm.postal_code" placeholder="Postal Code"/></p>
                  <p><input type="text" name="country" v-model="createAccountForm.country" placeholder="Country"/></p>
                  <p><input type="password" name="password" v-model="createAccountForm.password" placeholder="Password"/></p>
                  <p><input type="password" name="password_confirmation" v-model="createAccountForm.password_confirmation" placeholder="Re-Password"/></p>
                  <p class="form-checkbox"> <input id="send-notification" v-model="createAccountForm.send_notification" type="checkbox" name="send_notification" value="1"/> <label for="send-notification">Send notification</label></p>
                  <p class="form-checkbox"> <input id="send-email" v-model="createAccountForm.send_email" type="checkbox" name="send_email" value="1"/> <label for="send-email">Send Email</label></p>
                  <p class="form-checkbox"> <input id="terms" v-model="createAccountForm.term_and_condition" type="checkbox" name="term_and_condition" value="1"/> <label for="terms">Terms and conditions</label></p>
                  <button v-on:click="registerNewUser()" class="submit-login submit-register">Register</button>
                  <a class="checkout-form-cancel" v-on:click.prevent="backtoMainLoginScreen()" href="#">Cancel</a>
                </div>
              </div>

              <!--  Forgot password form -->
              <div :class="checkout.formType.forgotPasswordForm ? 'forgot-password-wrapper visible' : 'forgot-password-wrapper invisible'">
                <h2>Forgot password</h2>
                <div class="checkout-login-form">
                  <input type="password" name="password" placeholder="Password"/>
                  <button class="submit-login">
                    Reset my Password
                  </button>
                  <a class="checkout-form-cancel" v-on:click.prevent="backtoMainLoginScreen()" href="#">Cancel</a>
                </div>
              </div>


              <!--  guest checkout form -->
              <div :class="checkout.formType.guestCheckout ? 'checkout-overview visible' : 'checkout-overview invisible'">
                <h2 v-if="user.loggedIn">Checkout</h2>
                <h2 v-else>Checkout As Guest</h2>
                <div id="checkout_errors">
                  <template v-if="checkout.errors">
                    <p  class="validate-message" v-if="checkout.errors.status == 'badrequest'">{{ checkout.errors.message}}</p>
                  </template>
                </div>
                <div class="checkoutloading" v-if="checkout.loading">
                  <div class="loader" >Loading...</div>
                </div>
                <div class="checkout-overview-form">
                  <section class="checkout-user-info">
                    <h4>Contact</h4>
                    <div class="section-content">
                      <p><label>First Name</label> <input :disabled="user.loggedIn" v-model="contact.first_name" type="text" placeholder="First Name"/></p>
                      <p><label>Last Name</label> <input :disabled="user.loggedIn" v-model="contact.last_name" type="text" placeholder="Last Name"/></p>
                      <p><label>Phone</label> <input v-model="contact.phone" @keypress="isNumber()" type="text" placeholder="Phone No"/></p>
                      <p><label>Email</label> <input v-model="contact.email" type="text" placeholder="Email"/></p>
                    </div>
                  </section>

                  <section  class="checkout-order-details checkout-user-info" v-if="chooseMethods.selected.title != 'Pickup'">
                    <h4>Delivery address</h4>
                    <div class="section-content">
                      <div v-if="delivery.message.data != ''" class="delivery" :class="{'delivery-error':delivery.message.error, 'delivery-success': delivery.message.error != true}" >
                        <p>{{delivery.message.data}}</p>
                        <br>
                      </div>
                      <!--  <p><label>Address</label> <input v-model="delivery.address" type="text" placeholder="Address" /></p> -->
                      <p>
                        <label>Address</label>
                        <autocomplete
                                placeholder="Address"
                                input-class="search-address"
                                source="https://ecomm.api.unoapp.io/api/app/locations/googlelocation/"
                                results-property="item"
                                results-display="description"
                                @selected="getSearchLocationPlaceId"
                                @clear="resetDeliveryData">
                        </autocomplete>
                      </p>
                      <p><label>Address 1</label> <input v-model="delivery.address1" type="text" placeholder="Address 1"/></p>
                      <p><label>City</label> <input v-model="delivery.city" type="text" placeholder="City"/></p>
                      <p><label>Postal code</label> <input v-model="delivery.postalcode" type="text" placeholder="Postal code"/></p>
                      <p><label>Country</label> <input v-model="delivery.country" type="text" placeholder="Country"/></p>
                    </div>
                  </section>

                  <section class="checkout-payment-details">
                    <h4>Payment</h4>
                    <div class="section-content">
                      <p class="paylater" v-if="locations.selected.pay_later">
                        <input type="checkbox" id="paylater" v-model="payment.paylater" name="paylater"  value="1" /><label for="paylater">Pay later at restaurant.</label>
                      </p>
                      <template v-if="payment.paylater == false && stripe.enabled==false && bambora.enabled == false">
                        <div v-if="cayan.enabled" >
                          <p style="font-size:17px; color:red;"  v-if="cayan.errorMessage!=''">
                            Please check your<span v-if="cayan.errorMessage.length>1" >:</span>
                            <span class="cayanError" v-for="error in cayan.errorMessage" :key="error">
                  {{error}}<span v-if="cayan.errorMessage.length>1 && cayan.errorMessage.indexOf(error)!=cayan.errorMessage.length-1" >, </span>
                </span>
                          </p>
                        </div>
                        <div class="user-billing-lists" v-if="user.billingProfiles.length > 0">
                          <h4>Choose billing address </h4>
                          <ul>
                            <li v-for="(billing, index) in user.billingProfiles">
                              <input type="radio" v-model="payment.billingProfile" name="billingcard" :value="billing" :id="'billing_' + index"/> <label :for="'billing_' + index">{{ billing.card_type }} - {{ billing.last_digits}}</label>
                            </li>
                          </ul>
                        </div>
                        <div :class="locations.selected.pay_later ? 'add-new-billing-address' : 'default-billing-address'">
                          <p v-if="payeezy.error != ''" style="font-size:16px; color:red;" >{{payeezy.error}}</p>
                          <p class="card-detail">
                            <input @focus="cayan.errorMessage=[]" data-cayan="cardnumber" v-model="payment.card.cardNo" type="text" class="card-no" placeholder="Card Number"/>
                            <input @focus="cayan.errorMessage=[]" data-cayan="cvv" v-model="payment.card.cvv" type="text" class="cvv"  placeholder="CVV"/>
                          </p>
                          <p class="card-dates">
                            <select @focus="cayan.errorMessage=[]"  data-cayan="expirationmonth"  name="expiremonth"  class="card-exp-month" v-model="payment.card.month">
                              <option value="">Month</option>
                              <option value="01">1</option>
                              <option value="02">2</option>
                              <option value="03">3</option>
                              <option value="04">4</option>
                              <option value="05">5</option>
                              <option value="06">6</option>
                              <option value="07">7</option>
                              <option value="08">8</option>
                              <option value="09">9</option>
                              <option value="10">10</option>
                              <option value="11">11</option>
                              <option value="12">12</option>
                            </select>
                            <select @focus="cayan.errorMessage=[]" data-cayan="expirationyear" name="expireyear" class="card-exp-year" v-model="payment.card.year">
                              <option value="">Year</option>
                              <option value="2018">2018</option>
                              <option value="2019">2019</option>
                              <option value="2020">2020</option>
                              <option value="2021">2021</option>
                              <option value="2022">2022</option>
                              <option value="2023">2023</option>
                              <option value="2024">2024</option>
                              <option value="2025">2025</option>
                              <option value="2026">2026</option>
                              <option value="2027">2027</option>
                              <option value="2028">2028</option>
                              <option value="2029">2029</option>
                              <option value="2030">2030</option>
                            </select>
                          </p>
                          <a v-if="user.loggedIn" class="checkout-form-cancel" v-on:click.prevent="addNewBillingProfile()" href="#">Add new billing profile</a>
                        </div>
                      </template>
                      <div v-show="payment.paylater == false && stripe.enabled==false && cayan.enabled==false && bambora.enabled == true">
                        <!-- <div v-if="cayan.enabled" >
            <p style="font-size:17px; color:red;"  v-if="cayan.errorMessage!=''">
            Please check your<span v-if="cayan.errorMessage.length>1" >:</span>
            <span class="cayanError" v-for="error in cayan.errorMessage" :key="error">
            {{error}}<span v-if="cayan.errorMessage.length>1 && cayan.errorMessage.indexOf(error)!=cayan.errorMessage.length-1" >, </span>
          </span>
        </p>
      </div> -->
                        <div class="container">
                          <div v-if="bambora.error != ''" class="bamboraErrors">
                            {{bambora.error}}
                          </div>
                        </div>
                        <div :class="locations.selected.pay_later ? 'add-new-billing-address' : 'default-billing-address'">
                          <p class="card-detail">
                            <input type="text" id="bamboraCardNumber" v-model="bambora.data.cardNo" class="card-no" placeholder="Card Number"/>
                            <input type="text" id="bamboraCvv" class="cvv" v-model="bambora.data.cvv"  placeholder="CVV"/>
                          </p>
                          <p class="card-dates">
                            <select id="bamboraExpiryMonth" v-model="bambora.data.expiryMonth" name="expiremonth"  class="card-exp-month">
                              <option value="">Month</option>
                              <option value="01">1</option>
                              <option value="02">2</option>
                              <option value="03">3</option>
                              <option value="04">4</option>
                              <option value="05">5</option>
                              <option value="06">6</option>
                              <option value="07">7</option>
                              <option value="08">8</option>
                              <option value="09">9</option>
                              <option value="10">10</option>
                              <option value="11">11</option>
                              <option value="12">12</option>
                            </select>
                            <select id="bamboraExpiryYear" v-model="bambora.data.expiryYear" name="expireyear" class="card-exp-year">
                              <option value="">Year</option>
                              <option value="2018">2018</option>
                              <option value="2019">2019</option>
                              <option value="2020">2020</option>
                              <option value="2021">2021</option>
                              <option value="2022">2022</option>
                              <option value="2023">2023</option>
                              <option value="2024">2024</option>
                              <option value="2025">2025</option>
                              <option value="2026">2026</option>
                              <option value="2027">2027</option>
                              <option value="2028">2028</option>
                              <option value="2029">2029</option>
                              <option value="2030">2030</option>
                            </select>
                          <p class="card-detail">
                            <input type="text" class="card-no" v-model="bambora.data.billingAddress1" placeholder="billing Address Line 1"/>
                            <input type="text" v-model="bambora.data.city" class="cvv" placeholder="City"/>
                          </p>
                          <p class="card-detail">
                            <input type="text" class="card-no" v-model="bambora.data.province" placeholder="Province"/>
                            <input type="text" class="cvv" v-model="bambora.data.country" placeholder="Country"/>
                          </p>
                          <p class="card-detail">
                            <input type="text" class="card-no" v-model="bambora.data.postalCode" placeholder="Postal Code"/>
                          </p>
                          <a v-if="user.loggedIn" class="checkout-form-cancel" v-on:click.prevent="addNewBillingProfile()" href="#">Add new billing profile</a>
                        </div>
                      </div>
                      <form action="/charge" method="post" id="payment-form" v-show="stripe.enabled && payment.paylater === false">
                        <div class="form-row">
                          <label for="card-element">
                            Credit or debit card
                          </label>
                          <div id="card-element">
                            <!-- A Stripe Element will be inserted here. -->
                          </div>
                          <!-- Used to display Element errors. -->
                          <div id="card-errors" role="alert"></div>
                        </div>
                      </form>
                    </div>
                  </section>

                  <section v-if="locations.selected.location_profile.enable_tip" class="checkout-tip">
                    <h4>Tip</h4>
                    <div class="section-content">
                      <ul>
                        <li>
                          <input v-model="tip.percent" type="radio" id="tip-10" name="tip" value="10">
                          <label for="tip-10">10%</label>
                        </li>
                        <li>
                          <input  type="radio" id="tip-15" v-model="tip.percent" name="tip" value="15">
                          <label for="tip-15">15%</label>
                        </li>
                        <li>
                          <input  type="radio" id="tip-18" v-model="tip.percent" name="tip" value="18">
                          <label for="tip-18">18%</label>
                        </li>
                        <li>
                          <input type="radio" id="tip-20" v-model="tip.percent" name="tip" value="20">
                          <label for="tip-20">20%</label>
                        </li>
                        <li class="display-tip-price">
                          <input type="text" v-model.lazy="tip.amount"/>
                        </li>
                      </ul>
                    </div>
                  </section>
                  <section v-if="locations.selected.location_profile.enable_promocode" class="checkout-order-summary">
                    <h4>Promo Code</h4>
                    <div class="section-content">
                      <div class="promocode">
                        <p v-show="promoCode.displayError" :style="promoCode.style" >{{promoCode.errorMessage}}</p>

                        <p style="font-size:15px;" v-if="promoCode.appliedCodes.length>0">
                          Applied Codes:
                          <span class="promoCodeApplied"
                                v-for="code in promoCode.appliedCodes" @click="removePromoCode(code)">{{code}}
      </span>
                        </p>
                        <p><label>Promo Code:</label><input @focus="promoCode.displayError=false" v-model="promoCode.code" type="textbox" ><button @click="validatePromoCode()">Apply</button></p>
                      </div>
                    </div>
                  </section>

                  <section class="checkout-order-summary">
                    <h4>Order Summary</h4>
                    <div class="section-content">
                      <ul>
                        <li> Subtotal <span>${{ subtotal|| '$0.00' }}</span></li>
                        <li> Taxes <span>${{ tax || '$0.00' }}</span></li>
                        <li v-if="chooseMethods.selected.title=='Delivery'"> Delivery Charges <span>${{deliveryCharges}}</span></li>
                        <li v-if="locations.selected.location_profile.enable_tip"> Tip <span>${{ tip.amount }}</span></li>
                        <li v-if="promoCode.appliedCodes.length>0" >Promo Codes <span> - ${{promoTotal}}</span></li>
                        <li> Total <span>${{ grandtotal || '$0.00' }}</span></li>
                      </ul>
                    </div>
                  </section>

                  <section class="checkout-user-info">
                    <div class="section-content">
                      <p><label>Note</label> <textarea v-model="contact.note"></textarea></p>
                    </div>
                  </section>
                  <!--                           <el-tooltip :disabled="false" effect="dark" content="Store is currently closed. Please order during business hours." placement="top"> -->
                  <el-button v-on:click="generateToken()" ref="orderBtn" type="primary" style="width:100%;border-radius: 0;font-size:24px;">
                    Complete Order
                  </el-button>
                  <!--                            </el-tooltip> -->
                  <a class="checkout-form-cancel-btn" v-on:click.prevent="backtoMainLoginScreen()" style="width:100%;border-radius: 0;font-size:24px;" href="#">Cancel</a>
                </div>
              </div>

              <!--  Forgot password form -->
              <div :class="checkout.formType.thankyou ? 'forgot-password-wrapper visible' : 'forgot-password-wrapper invisible'">
                <h2>WE'VE GOT YOUR ORDER</h2>
                <img v-if="brand.logo" width="80%" style="position:relative;top:3px;" :src="brand.logo" :alt="brand.name"/>
                <div class="bold">  <h1> <u> Order Details </u> </h1> </div>
                <p>Order ID: {{ thankyou.orderId}}</p>
                <div class="bold">
                  Ordered from <br/>
                </div>
                <div class="secected-location-overview">
                  {{ locations.selected.display_name }} <br/>
                  {{ locations.selected.address_line_1 }} {{ locations.selected.address_line_2 }}
                  <br/>
                  {{ locations.selected.city }}, {{ locations.selected.province }}
                  <br/>
                  {{ locations.selected.postal_code }}
                </div>
                <br>
                <br>
                <div>
    <span @click="backToLocations" class="back-btn">
      <i class="fa fa-chevron-left"></i>
      BACK
    </span>
                </div>
              </div>

            </section>
          </div>

          <section v-show="currentSelectedMenu.selected === true" class="menu-item-detail">

            <div class="loader" v-if="currentSelectedMenu.object.length < 1">Loading...</div>
            <template v-else>
              <div class="item-img-header" >
                <img v-bind:src="currentSelectedMenu.object.image_url"  class="item-img-header img-shadow" />
              </div>
              <h3>
                {{ currentSelectedMenu.object.name }}
                <span>&dollar; {{ currentSelectedMenu.price_calculation }}</span>
              </h3>
              <p v-if="currentSelectedMenu.object.desc != currentSelectedMenu.object.name" v-text="currentSelectedMenu.object.desc"></p>
              <div class="quantity">
                <p>Choose a Quantity</p>
                <div  class="quantity-selector">
                  <button v-on:click="decQty()" class="btn quantity__minus">-</button>
                  <span class="num-quantity text--center">{{ pushtoCart.item_qty }}</span>
                  <button v-on:click="incQty()" class="btn quantity__plus">+</button>
                </div>
              </div>

              <template v-if="currentSelectedMenu.object.modifiers">
              <div class="modifiers-wrapper" v-if="currentSelectedMenu.object.modifiers.length > 0">
                <ul>
                  <li v-for="modifier in currentSelectedMenu.object.modifiers">
                    <label class="modifier-heading">{{ modifier.name }} <span v-if="modifier.min != 0"> Min {{ modifier.min }} required </span> <span v-if="modifier.included != 0"> ({{modifier.included}} included) </span></label>
                    <ul v-if="modifier.modifieritems" class="modifier-items">
                      <div v-for="modifieritem in modifier.modifieritems">
                        <label :for="'mi_' + modifieritem.id + modifieritem.sku">
                          <input type="checkbox" :id="'mi_' + modifieritem.id + modifieritem.sku" v-model="pushtoCart.modifiers" :value="modifieritem"> {{ modifieritem.name}} <span v-if="modifieritem.price > 0.00"> - &dollar;{{ modifieritem.price }}</span>
                        </label>
                        <br>
                      </div>
                    </ul>
                  </li>
                </ul>
              </div>
            </template>
            <div class="special-instruction-wrapper">
              <label for="instructions">Special Instructions (Optional)</label>
              <textarea id="instructions" v-model="pushtoCart.note"></textarea>
            </div>
            <el-button v-on:click="addToCart()" type="primary" style="width:100%;border-radius: 0;font-size:24px; height: 100% !important; margin-bottom: 100px;">
              Add to cart
            </el-button>
      </template>
      </section>
    </div>
</template>
</div>

<template v-if="!loginForm.direct && !checkout.formType.thankyou">
  <div v-if="step === 1" :class="cartItemToggle ? 'smallWhiteBg open' : 'smallWhiteBg'">
    <div class="mobile-headers cart-items-header">
      <a href="" v-on:click.prevent="cartItemToggle= false"> Back</a>
    </div>
    <div id="map" v-if="cartItemToggle==false" class="btm-border" style="height:150px;">
      <gmap-map v-if="locations.selected.latitude"
                :center="{lat: parseFloat(locations.selected.latitude), lng: parseFloat(locations.selected.longitude)}"
                :zoom="12"
                map-type-id="terrain"
                style="width: 100%; height: 150px"
      >
        <GmapMarker ref="myMarker"
                    :position="{lat: parseFloat(locations.selected.latitude), lng: parseFloat(locations.selected.longitude)}" />
      </gmap-map>
    </div>
    <div class="btm-border text-left pad-10" style="padding-top:0" >
      <div class="bold"> {{ locations.selected.display_name }} </div>
      <div class="secected-location-overview">
        {{ locations.selected.address_line_1 }} {{ locations.selected.address_line_2 }} {{ locations.selected.province }} {{ locations.selected.city }} <br>
        Phone : {{formattedPhoneNumber}} <br>
        Email : {{locations.selected.email}}
      </div>
    </div>
    <div class="btm-border text-left pad-10">
      <div class="secected-time-overview">
        {{ chooseTime.selected.title }} -
        <span v-if="chooseTime.orderLater.active">{{ chooseTime.orderLater.selectedDate.dayFull }} at {{ chooseTime.orderLater.selectedHour.hour }}:{{ chooseTime.orderLater.selectedHour.min }} {{ chooseTime.orderLater.selectedHour.ampm }} </span>- {{ chooseMethods.selected.title }}
      </div>
    </div>
    <div class="cartTotal">
      <div class="cartItems">
        <div v-for="(item, i) in cartItem" :key="item.id" class="hover cart-item-list select text-left pad-10">
        <span class="pad-10">
          {{ item.item_qty }}
        </span>
          <span class="pad-10">
          {{ item.name }}
        </span>
          <span class="fl-right">
          ${{ item.actual_price }}
          <i @click="removeCartItem(i)" class="fa fa-times remove-item"></i>
        </span>
          <p v-if="item.note" class="special-instructions">{{ item.note }}</p>
          <template v-if="item.modifiers">
            <div class="cart-item-modifiers">
              <ul>
                <li v-for="modifier in item.modifiers">
                  <p class="modifier-cat-title">{{ modifier.title }}</p>
                  <ul class="cart-modifier-cat-items" v-if="modifier.modifier_items">
                    <li v-for="modifieritem in modifier.modifier_items">
                      {{ modifieritem.name }} <span v-if="modifieritem.price != 0">{{ modifieritem.price }}</span> <span v-else> included </span>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </template>
        </div>
      </div>
      <div v-if="cartItem.length == '0'">
        <p>No item!</p>
      </div>
    </div>

    <div v-if="!checkout.formType.guestCheckout" class="top-border text-left greyBg bottom-fixed">
      <div class="bold pad-10">
        Subtotal:
        <span class="fl-right">
        {{ subtotal || '$0.00' }}
      </span>
      </div>
      <div class="bold pad-10">
        Taxes:
        <span class="fl-right">
        {{ tax || '$0.00' }}
      </span>
      </div>
      <div class="flex-center pad-10">
        <div class="storeClosed" v-if="this.locations.selected.location_profile === null || this.checkStoreStatus === false ||this.locations.selected.current_online_ordering_status===0">
          This location is not accepting online orders right now. <br> Please call : {{formattedPhoneNumber}} for more details.
        </div>
        <el-button v-else type="primary" v-on:click="gotoCheckout()" class="text-left" style="width:100%;font-size:inherit !important;">
          Checkout
          <span class="fl-right">
          ${{ total || '$0.00' }}
        </span>
        </el-button>
      </div>
    </div>
  </div>
</template>

<!-- popup -->
<div class="popup-wrap" v-if="chooseTime.orderNowAvailable">
  <div class="popup-content">
    <h3>Not taking online orders right now</h3>
    <h4>Pickup Hours</h4>
    <hr/>
    <table>
      <tbody>
      <tr v-if="chooseTime.orderNowOpenSchedule" v-for="item in chooseTime.orderNowOpenSchedule">
        <td v-text="item.day_name"></td>
        <td>{{ item.open_time }} - {{ item.close_time }}</td>
      </tr>
      </tbody>
    </table>
    <div class="popup-btn-wrapper">
      <button class="primary-btn" v-on:click="chooseTime.orderNowAvailable = false">Ok</button>
    </div>
  </div>
</div>
<!-- popup ends -->
</div>
</template>

<script>
	/* eslint-disable */
	//Promise Importer For Script
	import moment from "moment";
	import momenttimezone from "moment-timezone";
	import { SweetModal, SweetModalTab } from "sweet-modal-vue";
	// import { extendMoment } from 'moment-range';
	import { debounce } from "lodash";
	import Autocomplete from "vuejs-auto-complete";
	import $ from "jquery";
	// import anime from 'animejs'
	import { importer } from "../importer.js";
	import {Payeezy} from '../payeezy_us_v5.1.js'

	export default {
		name: "MainComponent",
		components: {
			Autocomplete,
			SweetModal,
			SweetModalTab
		},
		beforeDestroy() {
			this.numOfRequire = 0;
		},

		data() {
			return {
				autoCompleteDataSource:[],
				modalErrorMessage: '',
				brand_id: null,
				brand: {
					name: "",
					logo: ""
				},
				user: {
					loggedIn: false,
					detail: {},
					session: {},
					billingProfiles: []
				},

				loginForm: {
					direct: false,
					user_name: "aashish@unoapp.com",
					password: "Spoonity1",
					error: {
						status: "",
						message: ""
					}
				},

				createAccountForm: {
					brand_id: this.brand_id,
					form: false,
					first_name: "",
					last_name: "",
					email: "",
					phone: "",
					address: "",
					address2: "",
					city: "",
					province: "",
					postal_code: "",
					country: "",
					password: "",
					password_confirmation: "",
					send_notification: "",
					send_email: "",
					platform: "web",
					register_from: "web",
					app_version: "1.0.0",
					term_and_condition: "",
					error: {
						status: "",
						message: ""
					}
				},
				forgotPassword: {
					form: false,
					email: "",
					error: {
						status: "",
						message: ""
					}
				},
				locations: {
					active: true,
					selected: "",
					name: "Location",
					icon: "fa-map-marker",
					data: [],
					delivery_status: false
				},

				chooseTime: {
					active: false,
					orderNowAvailable: false,
					orderNowOpenSchedule: [],
					orderLater: {
						active: false,
						days: {},
						availableHours: [],
						selectedDate: {},
						selectedHour: ""
					},
					selected: "",
					name: "Time",
					icon: "fa-clock-o",
					data: [
						{
							identifier: "now",
							title: "Order Now",
							desc: "Have your order prepared asap"
						},
						{
							identifier: "later",
							title: "Order Later",
							desc:
								"Have your order prepared at a specific date and time in the future"
						}
					]
				},

				chooseMethods: {
					active: false,
					selected: "",
					name: "Method",
					icon: "fa-cutlery",
					data: [
						{
							title: "Pickup",
							desc: "Pickup your order at the store"
						},
						{
							title: "Delivery",
							desc: "Your order will be delivered to you"
						}
					]
				},
				menuItems: {
					active: false,
					data: []
				},
				currentSelectedMenu: {
					selected: false,
					object: [],
					price_calculation: 0
				},

				pushtoCart: {
					item_id: null,
					item_qty: 1,
					base_price: "",
					actual_price: "",
					note: "",
					modifiers: [],
					modifiersOrdered: [],
					errorMessage: ""
				},

				checkout: {
					loading: false,
					form: false,
					formType: {
						mainForm: false,
						registerForm: false,
						forgotPasswordForm: false,
						guestCheckout: false,
						logoutForm: false,
						thankyou: false
					},
					email: "",
					password: "",
					errors: {}
				},

				tip: {
					percent: "",
					amount: 0.0
				},

				contact: {
					first_name: "",
					last_name: "",
					phone: "",
					email: "",
					note: ""
				},

				delivery: {
					address: "",
					address1: "",
					city: "",
					postalcode: "",
					country: "",
					latitude: "",
					longitude: "",
					place_id: "",
					message: {
						error: false,
						data: ''
					},
					deliveryCharges: 0
				},

				payment: {
					card: {
						cardNo: "",
						cvv: "",
						month: "",
						year: ""
					},
					billingProfile: "",
					postalCode: "",
					paylater: false
				},

				selectedSection: [null, null, null],

				cartItem: [],
				cartItemToggle: false,

				thankyou: {
					orderid: ""
				},

				sections: [],
				step: 0,
				selectedItem: null,
				numOfRequire: 0,
				singleLocation: false,
				stripe: {
					library: "",
					card: "",
					key: "",
					enabled: false,
					TokenID: ""
				},
				stripeDetails: {
					stripeUSKey: "pk_test_o1aBWckozAE0xju1mTOUOuhj",
					stripeCanadaKey: "pk_test_0FHrvbS87h6ZFMm1nm8hXvi4"
				},
				promoCode: {
					code: "",
					displayError: "",
					style:{display:"inline",fontWeight:"400"},
					errorMessage: "",
					appliedCodes: [],
					discountApplied:[]
				},
				cayan: {
					enabled: false,
					token: '',
					errorMessage:[]
				},
				bambora: {
					enabled: false,
					data: {
						cardNo: '',
						cvv: '',
						expiryMonth: '',
						expiryYear: '',
						billingAddress1: '',
						city: '',
						state: '',
						postalCode: '',
						country: '',
						phone: ''
					},
					token: ''
				},
				payeezy: {
					enabled: false,
					token: '',
					error: ''
				}
			};
		},
		watch: {
			"user.loggedIn": function() {
				this.contact.name = this.user.detail.first_name;
				// now get user billing detsils
				this.getBillingProfiles();
			},

			"tip.percent": function(val) {
				var tipsAmount = this.total * val;
				tipsAmount = tipsAmount / 100;
				this.tip.amount = tipsAmount.toFixed(2);
			},
			"tip.amount": function () {
				if (this.tip.amount === ""){
					this.tip.amount = 0
				}
			},
			"pushtoCart.modifiers": function(val) {
				// on selecting modifier need to check it must not exceed max value
				this.calculateSelectedProductTotal();
				let self = this;
				let total_modifiers = this.pushtoCart.modifiers;

				if (
					this.pushtoCart.modifiers &&
					this.pushtoCart.modifiers[this.pushtoCart.modifiers.length - 1]
				) {
					var modifiers_id = this.pushtoCart.modifiers[
					this.pushtoCart.modifiers.length - 1
						].modifier_id;
				} else {
					return;
				}
				let maximum = 0;
				for (
					let i = 0;
					i < this.currentSelectedMenu.object.modifiers.length;
					i++
				) {
					let mods = this.currentSelectedMenu.object.modifiers[i];
					if (
						mods.id === modifiers_id &&
						this.currentSelectedMenu.object.modifiers[i].min === 0
					) {
						// if mataches and has a maximum
						maximum = this.currentSelectedMenu.object.modifiers[i].max;
					}
					if (
						mods.id === modifiers_id &&
						this.currentSelectedMenu.object.modifiers[i].min != 0
					) {
						this.numOfRequire += 1;
					}
				}
				// console.log(maximum)
				// console.log(modifiers_id)
				let countModifierID = 0
				total_modifiers.forEach((mod) => {
					if (mod.modifier_id === modifiers_id) countModifierID += 1
				})
				if (total_modifiers.length > 0 && maximum > 0) {
					if (countModifierID - this.numOfRequire > maximum) {
						// self.disabled = true
						// self.pushtoCart.errorMessage =
						//   "Please select at most " + maximum + " toppings";
						self.modalErrorMessage = "Please select at most " + maximum + " toppings"
						self.$refs.test.open();
						self.pushtoCart.modifiers.pop();
					}
				}
			},
			"pushtoCart.item_qty": function(val) {
				this.calculateSelectedProductTotal();
			}
		},
		mounted() {
			const self = this;
			this.contact = this.getEnvDetails().testData.contact
			this.payment.card = this.getEnvDetails().testData.card
			this.stripeDetails = this.getEnvDetails().stripeDetails
			this.getbrandId();
			this.getFutureSevenDays();
			// CORE
			this.$on("brandID", function(response) {
				self.brand_id = response.data.payload.brand.id;
				self.getLocations();
				self.getBrandDetails();
			});

			this.$on("brand-details", function(response) {
				self.brand = response.data.payload;
			});

			this.$on("locations", function(response) {
				self.locations.data = response.data.payload;
				// If only one location is availabe autop select
				if (self.locations.data.length == "1") {
					self.selectSection("location", response.data.payload[0]);
					self.singleLocation = true;
				}
				//.
			});
			this.$on("menu-category", function(response) {
				if (response.code == "500") {
					alert(response.payload);
					return false;
				}
				self.menuItems.data = response.data.payload;
				// after pending data let init jqueyr for toggle
				this.initMenuItemsToggle();
			});

			this.$on("item-detail", function(response) {
				self.currentSelectedMenu.object = response.data.payload[0];
				self.currentSelectedMenu.price_calculation =
					response.data.payload[0].price;
			});

			this.$on("delivery-location-detail", function(response) {
				self.canDeliver(response.geometry.location.lat, response.geometry.location.lng)
				self.delivery.latitude = response.geometry.location.lat;
				self.delivery.longitude = response.geometry.location.lng;
				self.delivery.address = response.formatted_address;
				for (var i = 0; i < response.address_components.length; i++) {
					var item = response.address_components[i];
					for (var j = 0; j < item.types.length; j++) {
						var subItem = item.types[j];
						if (subItem === "postal_code" || subItem === "postal_code_prefix") {
							self.delivery.postalcode = item.long_name;
						} else if (subItem === "country") {
							self.delivery.country = item.long_name;
						} else if (subItem === "administrative_area_level_2") {
							self.delivery.address1 = item.long_name;
						} else if (subItem === "administrative_area_level_1") {
							self.delivery.province = item.long_name;
						} else if (subItem === "locality") {
							self.delivery.city = item.long_name;
						}
					}
				}
			});

			this.$on("create-new-user", function(response) {
				self.createAccountForm.error = response;
				setTimeout(function(e) {
					$("html, body").animate(
						{
							scrollTop: $("#alert-register").offset().top
						},
						1000
					);
				}, 1000);
			});

			this.$on("user-billing-profiles", function(response) {
				self.user.billingProfiles = response.data.payload;
			});

			this.$on("guest-checkout", function(response) {
				if (response.code != 200) {
					self.checkout.errors.status = "badrequest";
					self.checkout.errors.message = response.message;
					$(".menu-items-wrapper").scrollTop(0);
					self.checkout.loading = false;
				} else {
					self.enableCheckoutForm("thankyou");
					self.thankyou.orderId = response.payload.external_id;
					self.checkout.loading = false;
				}
			});

			this.$on("login", function(response) {
				(self.user.loggedIn = true), (self.user.detail = response.payload);
				self.user.session = response.session;
				// after login check if user came from direct link
				if (this.loginForm.direct) {
					self.reset();
				} else {
					this.enableCheckoutForm("guestCheckout");
				}
			});

			// If any cart item preset  insert
			var localCartItem = localStorage.getItem("cartitem");
			// if(localCartItem) {
			//   this.cartItem = JSON.parse(localCartItem)
			// }
			// now check user is logged in or no
			var user_detail = localStorage.getItem("user_detail");
			var user_session = localStorage.getItem("user_session");
			if (user_session) {
				(this.user.loggedIn = true), (this.user.detail = JSON.parse(user_detail));
				this.user.session = JSON.parse(user_session);
			}

		},
		methods: {
			// autocompleteData () {
			//   console.log('b')
			//   var self = this
			//   let input = document.getElementsByClassName('autocomplete__inputs')[0].children[0].value
			//   let url = "https://ecomm.api.unoapp.io/api/app/locations/googlelocation/" + input
			//   this.axios.get(url)
			//     .then(success => {
			//       console.log(success);
			//       self.autoCompleteDataSource = success.data
			//     })
			//     .catch(error => {
			//       console.log(error)
			//     });
			// },
			generateToken() {

				if (this.stripe.enabled && this.payment.paylater == false) {
					let vueThis = this;
					this.stripe.library
						.createToken(vueThis.stripe.card)
						.then(function(result) {
							if (result.error) {
								var errorElement = document.getElementById("card-errors");
								errorElement.textContent = result.error.message;
							} else {
								vueThis.stripe.TokenID = result.token.id;
								vueThis.completeOrder();
							}
						});
					return;
				}
				if(this.payment.paylater == false && this.cayan.enabled){
					this.generateCayanToken()
					return;
				}

				if(this.payment.paylater == false && this.cayan.enabled == false && this.stripe.enabled == false && this.bambora.enabled){
					this.generateBamboraToken()
					return;
				}

				if(this.payment.paylater == false && this.cayan.enabled == false && this.stripe.enabled == false && this.bambora.enabled == false && this.payeezy.enabled) {
					this.generatePayeezyToken()
					return
				}
				this.completeOrder()
			},
			initBambora() {
				var customCheckout = customcheckout();
				this.bambora.lib = customCheckout

				let options = {}
				options.placeholder = 'Card number'
				options.classes = {base:'card-no'}
				var cardNumber = customCheckout.create('card-number', options)
				cardNumber.mount('#bamboraCardNumber')

				options = {}
				options.placeholder = 'CVV'
				options.classes = {base:'card-no'}

				var cardCvv = customCheckout.create('cvv', options)
				cardCvv.mount('#bamboraCardCvv')
				options = {}
				options.placeholder = 'Card Expiry: MM/YY'
				options.classes = {base:'bamboraExpiry'}
				var cardExpiry = customCheckout.create('expiry', options)
				cardExpiry.mount('#bamboraCardExpiry')
			},
      generatePayeezyToken () {
        var self = this
        this.getPayeezyDetails().then((success) => {
          console.log(JSON.parse(success.data.payload.payment_info))
          var paymentDetails = JSON.parse(success.data.payload.payment_info)
          Payeezy.setEndpoint(this.getEnvDetails().payeezy.endpoint)
          Payeezy.setApiKey(paymentDetails.apiKey)
          Payeezy.setJs_Security_Key(paymentDetails['js-token'])
          Payeezy.setTa_token(paymentDetails.ta_token)
          Payeezy.setAuth('true')
          Payeezy.setCardNumber(this.payment.card.cardNo)
          let name = this.contact.first_name + ' ' + this.contact.last_name
          Payeezy.setCardHolderName(name)
          Payeezy.setCVV(this.payment.card.cvv)
          Payeezy.setExpiryMonth(this.payment.card.month)
          Payeezy.setExpiryYear(this.payment.card.year[this.payment.card.year.length-2]+this.payment.card.year[this.payment.card.year.length-1])
          Payeezy.setCardType(this.detectCardType(this.payment.card.cardNo))
          Payeezy.createToken(function(status, response) {
            if(status == '401') {
              self.payeezy.error = "Please check your card details and try again."
            }   else if (status == '201') {
              let tokenObject = {}
              tokenObject.type = "FDToken"
              tokenObject.token = response.token
              self.payeezy.token = tokenObject
              self.completeOrder()
            }
          })
        }).catch((error) => {
          console.log(error)
      })
    },getPayeezyDetails() {
      return this.axios.get(this.getEnvDetails().payeezy.keyDetails, {headers: this.getHeaders()})
    },
			generateBamboraToken () {
				var self = this
				let data = {
					"card": this.bambora.data.cardNo,
					"expiry_month": parseInt(this.bambora.data.expiryMonth),
					"expiry_year": this.bambora.data.expiryYear,
					"cvv": this.bambora.data.cvv,
					"gateway":"bambora",
					'postcode': this.bambora.data.postalcode,
					'country': this.bambora.data.country,
					'first_name': this.contact.first_name,
					'last_name': this.contact.last_name,
					'brand_id': this.locations.selected.brand_id,
					'city': this.bambora.data.city,
					'address': this.bambora.data.billingAddress1,
					'email':  this.contact.email,
					'phone': this.contact.phone,
					'province': this.bambora.data.province,
					'postcode': this.bambora.data.postalCode,
				}
				this.axios.post(this.getEnvDetails().bamboraEndpoint, data, {headers:this.getHeaders()}).then((response) => {
					self.bambora.token = response.data.payload.token
					this.completeOrder()
				}).catch((error) => {
					console.log(error)
				})
			},
			generateCayanToken () {
				importer.url("https://ecommerce.merchantware.net/v1/CayanCheckoutPlus.js").then(() => {
					CayanCheckoutPlus.setWebApiKey("DYDLDQJF0KFE6QTK");
					CayanCheckoutPlus.createPaymentToken({
						success: this.cayanSuccess,
						error: this.cayanError
					})
				});
			},
			cayanError (error) {
				console.log('at the error block')
				for(let x = 0; x<error.length; x++){
					if(error[x].error_code=="VALIDATION" || error[x].error_code=="REQUIRED"){
						if(error[x].reason=="cardnumber" && !this.cayan.errorMessage.includes('card number')){
							this.cayan.errorMessage.push('card number')
						}
						if(error[x].reason=="cvv" && !this.cayan.errorMessage.includes('CVV')){
							this.cayan.errorMessage.push('CVV')
						}
						if(error[x].reason=="expirationmonth" && !this.cayan.errorMessage.includes('card\'s expiration month')){
							this.cayan.errorMessage.push('card\'s expiration month')
						}
						if(error[x].reason=="expirationdate" && !this.cayan.errorMessage.includes('card\'s expiration year')
							|| error[x].reason=="expirationyear" && !this.cayan.errorMessage.includes('card\'s expiration year')){
							this.cayan.errorMessage.push('card\'s expiration year')
						}
					}
				}
			},
			cayanSuccess (tokenResponse) {
				this.cayan.token = tokenResponse.token
				console.log(tokenResponse)
				this.completeOrder()
			},

			stripeInit() {
				// Create a Stripe client.
				var stripe = Stripe(this.stripe.key);
				this.stripe.library = stripe;
				// Create an instance of Elements.
				var elements = stripe.elements();
				// Custom styling can be passed to options when creating an Element.
				// (Note that this demo uses a wider set of styles than the guide below.)
				var style = {
					base: {
						color: "#32325d",
						lineHeight: "18px",
						fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
						fontSmoothing: "antialiased",
						fontSize: "16px",
						"::placeholder": {
							color: "#aab7c4"
						}
					},
					invalid: {
						color: "#fa755a",
						iconColor: "#fa755a"
					}
				};
				// Create an instance of the card Element.
				var card = elements.create("card", { style: style });
				this.stripe.card = card;
				// Add an instance of the card Element into the `card-element` <div>.
				card.mount("#card-element");
				// Handle real-time validation errors from the card Element.
				card.addEventListener("change", function(event) {
					var displayError = document.getElementById("card-errors");
					if (event.error) {
						displayError.textContent = event.error.message;
					} else {
						displayError.textContent = "";
					}
				});
			},
			removePromoCode (code) {
				this.promoCode.appliedCodes.splice(this.promoCode.appliedCodes.indexOf(code), 1)
				this.promoCode.discountApplied.splice(this.promoCode.appliedCodes.indexOf(code), 1)
				this.promoCode.style.color='blue'
				this.promoCode.style.fontSize='16px'
				this.promoCode.displayError=true
				this.promoCode.errorMessage = "Promo code removed."
				this.promoCode.appliedCodes.indexOf(code)
			},
			validatePromoCode() {
				var self = this
				if(this.promoCode.appliedCodes.includes(this.promoCode.code)){
					self.promoCode.style.color='red'
					self.promoCode.style.fontSize='16px'
					self.promoCode.displayError=true
					self.promoCode.errorMessage = "The Promo code has already been applied."
					return;
				}

				var data={
					"brand_id": this.locations.selected.brand_id,
					"location_id":this.locations.selected.location_profile.location_id,
					"promocode": this.promoCode.code,
					"items": this.cartItem
				}
				axios
					.post(this.getEnvDetails().promocodeEndpoint, data,{ headers: this.getHeaders() })
					.then(function(response) {
						self.promoCode.appliedCodes.push(self.promoCode.code.toLowerCase())
						self.promoCode.discountApplied.push(response.data.payload.applyAmount)
						self.promoCode.style.color='green'
						self.promoCode.style.fontSize='16px'
						self.promoCode.displayError=true
						self.promoCode.errorMessage = response.data.message
						self.promoCode.code = ''
					})
					.catch(function(error) {
						self.promoCode.style.color='red'
						self.promoCode.style.fontSize='16px'
						self.promoCode.displayError=true
						self.promoCode.errorMessage = error.response.data.message
					});
			},

			calculateSelectedProductTotal() {
				var actualPrice = this.currentSelectedMenu.object.price;
				var modifierPrice = 0;
				if (this.pushtoCart.modifiers.length > 0) {
					for (var key in this.pushtoCart.modifiers) {
						modifierPrice += parseFloat(this.pushtoCart.modifiers[key].price);
					}
				}

				// lets order modifers depending of key

				var modifiersOrdered = {};
				if (this.pushtoCart.modifiers.length > 0) {
					var itemModifiers = this.pushtoCart.modifiers;
					itemModifiers.map(function(item) {
						if (item) {
							// If its not an array make array then push
							if (
								modifiersOrdered["head_mod_" + item.modifier_id] === undefined
							) {
								modifiersOrdered["head_mod_" + item.modifier_id] = {
									id: item.modifier.id,
									title: item.modifier.name,
									max: item.modifier.max,
									min: item.modifier.min,
									included: 1,
									modifier_items: [
										{
											modifier_item_id: item.id,
											mod_qty: 1,
											mod_qty_rounded: 1,
											included: 1,
											name: item.name,
											price: item.price
										}
									]
								};
							} else {
								modifiersOrdered[
								"head_mod_" + item.modifier_id
									].modifier_items.push({
									modifier_item_id: item.id,
									mod_qty: 1,
									mod_qty_rounded: 1,
									included: 1,
									price: item.price,
									name: item.name
								});
							}
						}
					});
				}

				this.pushtoCart.modifiersOrdered = modifiersOrdered;
				var selectedItemPrice =
					parseFloat(actualPrice) + parseFloat(modifierPrice);
				var selectedItemPriceTotal = selectedItemPrice;
				this.currentSelectedMenu.price_calculation = selectedItemPriceTotal.toFixed(
					2
				);
			},

			getSearchLocationPlaceId(group) {
				console.log(group)
				this.delivery.place_id = group.selectedObject.place_id;
				if (group.selectedObject.place_id) {
					this.getLocationFromPlaceId(group.selectedObject.place_id)
				}
			},
			canDeliver (lat,lng) {
				let data = {
					location_id: this.locations.selected.id,
					latitude: lat,
					longitude: lng
				}
				let self = this
				this.axios.post(this.getEnvDetails().deliveryEndpoint, data, {headers: this.getHeaders()}).then((success) => {
					self.delivery.message.error = false
					self.delivery.message.data = "Will deliver to the location for $" + success.data.payload.calculated_delivery_fees + "."
					self.delivery.deliveryCharges = success.data.payload.calculated_delivery_fees
				}).catch((error) => {
					console.log(error.response.data.message)
					self.delivery.message.error = true
					self.delivery.message.data = error.response.data.message
				})
			},
			resetDeliveryData () {
				this.delivery.message.error = false
				this.delivery.message.data = ''
				this.delivery.deliveryCharges = 0
			},

			addNewBillingProfile() {
				var cartType = this.detectCardType(this.payment.card.cardNo);
				// validate card type
				var obj = {
					gateway: "merchant_link",
					profile_id: "123456789",
					last_digits: this.payment.card.cvv,
					card_type: cartType
				};
				console.log(this.payment.card.cardNo);
				console.log(cartTypeNo);
				// this.setBillingProfiles()
			},
			detectCardType(number) {
				var re = {
					electron: /^(4026|417500|4405|4508|4844|4913|4917)\d+$/,
					maestro: /^(5018|5020|5038|5612|5893|6304|6759|6761|6762|6763|0604|6390)\d+$/,
					dankort: /^(5019)\d+$/,
					interpayment: /^(636)\d+$/,
					unionpay: /^(62|88)\d+$/,
					visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
					mastercard: /^5[1-5][0-9]{14}$/,
					amex: /^3[47][0-9]{13}$/,
					diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
					discover: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
					jcb: /^(?:2131|1800|35\d{3})\d{11}$/
				};

				for (var key in re) {
					if (re[key].test(number)) {
						return key;
					}
				}
				return "invalid card!";
			},

			completeOrder() {

				$(".menu-items-wrapper").scrollTop(0);
				this.checkout.loading = true;
				var self = this;
				this.checkout.errors = {};
				var placeorder = {
					pickup_later: this.chooseTime.orderLater.active,
					pay_later: this.payment.paylater ? this.payment.paylater : "0",
					checkout_type: "guest",
					promocode:this.promoCode.appliedCodes,
					user: {
						first_name: this.contact.first_name,
						last_name: this.contact.last_name,
						email: this.contact.email,
						phone: this.contact.phone,
						brand_id: this.brand_id
					},

					note: this.contact.note,
					is_group_order: false,
					is_delivery:
						this.chooseMethods.selected.title == "Delivery" ? "1" : "0",

					address_1: this.delivery.address,
					address_2: this.delivery.address1,
					city: this.delivery.city,
					postal_code: this.delivery.postalcode,
					country: this.delivery.country,
					latitude: this.delivery.latitude,
					longitude: this.delivery.longitude,
					location_id: this.locations.selected.id,

					cart_type: "regular",
					items: this.cartItem
				};

				var selectedFullDateTime =
					this.chooseTime.orderLater.selectedDate.fullDate +
					" " +
					this.chooseTime.orderLater.selectedHour.global_hour;
				var locationTime = moment.tz(
					selectedFullDateTime,
					this.locations.selected.timezone
				);
				var utcTime = moment.utc(locationTime).format("YYYY-MM-DD HH:mm:ss");
				console.log(locationTime);
				console.log(utcTime);
				if (utcTime) {
					placeorder.pickupdatetime = utcTime
				}

				// var selectedTime = this.chooseTime.orderLater.selectedHour.global_hour;
				// var date = moment(this.chooseTime.orderLater.selectedDate.fullDate)
				// // day of week of selected Time
				// var dow = this.locations.selected.location_hours[date.day()]
				// placeorder.pickupdatetime = selectedTime

				if (this.locations.selected.location_profile.enable_tip) {
					placeorder.tip_amount = this.tip.amount;
				}

				// if order later hide ->   delivery

				if (
					!this.contact.first_name ||
					!this.contact.phone ||
					!this.contact.email
				) {
					this.checkout.errors.status = "badrequest";
					this.checkout.errors.message = "Please provide your contact details.";
					$(".menu-items-wrapper").scrollTop(0);
					this.checkout.loading = false;
					return false;
				}

				if (!this.payment.paylater && this.stripe.enabled == false && this.cayan.enabled == false && this.bambora.enabled == false && this.payeezy.enabled == false) {
					if (!this.payment.card.year || !this.payment.card.cardNo) {
						this.checkout.errors.status = "badrequest";
						this.checkout.errors.message = "Blank card details.";
						$(".menu-items-wrapper").scrollTop(0);
						this.checkout.loading = false;
						return false;
					}
					// Start loading here

					var data = {
						card: this.payment.card.cardNo,
						expiry: this.payment.card.year,
						merchant_id: this.locations.selected.location_profile.merchant_id,
						merchant_key: this.locations.selected.location_profile.merchant_key
					};

					this.axios
						.post(
							this.getEnvDetails().monerisEndpoint,
							data,
							{ headers: this.getHeaders() }
						)
						.then(success => {
							placeorder.payment_token = success.data.payload.DataKey;
							self.submitGuestCheckout(placeorder);
							console.log("success error");
						})
						.catch(error => {
							console.log(error)
							this.checkout.errors.status = "badrequest";
							this.checkout.errors.message = "Invalid merchant details."; //error.data.message[0];
							this.checkout.loading = false;
						});
				} else if (this.stripe.enabled == true && this.payment.paylater == false
				) {
					placeorder.payment_token = this.stripe.TokenID;
					self.submitGuestCheckout(placeorder);
					console.log("success error");
				}
				else if(this.cayan.enabled && this.payment.paylater == false){
					placeorder.payment_token = this.cayan.token
					self.submitGuestCheckout(placeorder)
				}
				else if(this.bambora.enabled && this.payment.paylater == false) {
					placeorder.payment_token = this.bambora.token
					self.submitGuestCheckout(placeorder)
				}
				else if (this.payeezy.enabled && this.payment.paylater == false) {
					placeorder.payment_token = this.payeezy.token
					self.submitGuestCheckout(placeorder)
				}
				else {
					// pay later
					this.submitGuestCheckout(placeorder);
				}

				// reset checkout details
			},

			guestCheckout() {
				this.enableCheckoutForm("guestCheckout");
			},

			displayLoginForm() {
				// display login direct
				this.loginForm.direct = true;
				this.step = 1;
				this.checkout.form = true;
				this.currentSelectedMenu.selected = false;
				this.enableCheckoutForm("mainForm");
			},
			displayLogoutForm() {
				this.loginForm.direct = true;
				this.step = 1;
				this.checkout.form = true;
				this.enableCheckoutForm("logoutForm");
			},
			logout() {
				localStorage.removeItem("user_detail");
				localStorage.removeItem("user_session");
				this.payment.paylater = false;
				this.user.loggedIn = false;
				this.user.detail = {};
				this.user.session = {};
				this.enableCheckoutForm("reset");
				this.reset();
				this.user.billingProfiles = {};
			},
			registerNewUser() {
				this.createNewAccount(this.createAccountForm);
			},

			displayForgotPasswordForm() {
				this.enableCheckoutForm("forgotPasswordForm");
			},

			createAnAccount() {
				this.enableCheckoutForm("registerForm");
			},

			backtoMainLoginScreen() {
				//  if(this.isUserLoggedIn()) {

				//    this.backToMenuList()

				//  } else {
				//     this.enableCheckoutForm('mainForm')
				//  }

				//  NOTE: hide login for now
				this.backToMenuList();
			},
			backToLocations() {
				this.locations.active = true;
				this.chooseTime.active = false;
				this.step = 0;
				this.reset();
			},

			enableCheckoutForm(formKey) {
				for (var key in this.checkout.formType) {
					if (key == formKey) {
						this.checkout.formType[key] = true;
					} else {
						this.checkout.formType[key] = false;
					}
				}
			},

			initMenuItemsToggle() {
				setTimeout(function() {
					$(".main-cat-list").on("click", function(e) {
						if ($(this).hasClass("open")) {
							$(this)
								.parent()
								.find(".sub-cat-ul")
								.slideUp();
							$(this)
								.parent()
								.siblings()
								.removeClass("open");
							$(this).toggleClass("open");
						} else {
							$(this)
								.parent()
								.find(".sub-cat-ul")
								.slideToggle();
							$(this).toggleClass("open");
							$(this)
								.parent()
								.siblings()
								.find(".sub-cat-ul")
								.slideUp();
							$(this)
								.parent()
								.siblings()
								.removeClass("open");
						}
					});

					$(".sub-cat-list").on("click", function(e) {
						$(this)
							.parent()
							.find(".sub-sub-cat-ul")
							.slideToggle();
						$(this).toggleClass("open");

						$(this)
							.parent()
							.siblings()
							.find(".sub-sub-cat-ul")
							.slideUp();
						$(this)
							.parent()
							.siblings()
							.find(".sub-cat-list")
							.removeClass("open");
					});

					$(".sub-sub-cat-list").on("click", function(e) {
						$(this)
							.parent()
							.find(".sub-sub-sub-cat-ul")
							.slideToggle();
						$(this).toggleClass("open");

						$(this)
							.parent()
							.siblings()
							.find(".sub-sub-sub-cat-ul")
							.slideUp();
						$(this)
							.parent()
							.siblings()
							.find(".sub-sub-cat-list`")
							.removeClass("open");
					});
				}, 500);
			},

			setStepOne() {
				this.step = 1;
				this.initMenuItemsToggle();
				//Set the stripe test key of the location
				if (this.locations.selected.currency.toLowerCase() === "cad") {
					this.stripe.key = this.stripeDetails.stripeCanadaKey;
				} else {
					this.stripe.key = this.stripeDetails.stripeUSKey;
				}
			},

			addToCart() {
				var error = false;
				this.numOfRequire = 0;
				var self = this;
				var groupMinMax = {};
				var gbModifiers = this.currentSelectedMenu.object.modifiers;
				gbModifiers.map(function(item, key) {
					if (error) {
						// self.pushtoCart.errorMessage = ''
						return false;
					}
					var groupId = item.id;
					var groupMin = item.min;
					var groupMax = item.max;
					if (groupMin > 0) {
						// get value from user cart
						if (self.pushtoCart.modifiersOrdered.length < 1 || self.pushtoCart.modifiersOrdered["head_mod_" + groupId] === undefined) {
							console.log('if1')
							self.modalErrorMessage =
								"Please select at least " + groupMin + " from " + item.name;
							self.$refs.test.open();
							error = true;
							return false;
						}
						// if (
						//   self.pushtoCart.modifiersOrdered["head_mod_" + groupId] === undefined
						// ) {
						//   console.log('if2')
						//   self.pushtoCart.errorMessage =
						//     "Please select at least " + groupMin + " from " + item.name;
						//   self.$refs.test.open();
						//   error = true;
						//   return false;
						// }
						else {
							var userAddedModifier =
								self.pushtoCart.modifiersOrdered["head_mod_" + groupId]
									.modifier_items;
							console.log('if3')
							// if(!userAddedModifier){
							//     alert('please select at least '+ groupMin + 'from ' + item.name)
							//     error = true;
							//      return false
							// }
							if (userAddedModifier.length < parseInt(groupMin)) {
								self.pushtoCart.errorMessage =
									"Please select at least " + groupMin + " from " + item.name;
								self.$refs.test.open();

								error = true;
								return false;
							}
						}
					}

					if (groupMax > 0) {
						// get value from user cart
						if (
							self.pushtoCart.modifiersOrdered["head_mod_" + groupId] ===
							undefined
						) {
						} else {
							var userAddedModifier =
								self.pushtoCart.modifiersOrdered["head_mod_" + groupId]
									.modifier_items;
							if (userAddedModifier.length > parseInt(groupMax)) {
								self.pushtoCart.errorMessage =
									"Please select at upto " + groupMax + " from " + item.name;
								self.$refs.test.open();
								error = true;
								return false;
							}
						}
					}
				});

				if (error) {
					return false;
				}

				// validate whther user missed ani min values and exceed any max values
				var self = this;
				// var modifierPrice = 0;
				// if(this.pushtoCart.modifiers.length > 0){
				//    var addedItemModifiers = this.pushtoCart.modifiers
				//    addedItemModifiers.map(function(item){
				//        modifierPrice += parseInt(item.price)
				//    })
				// }
				// var totalPricePer =  parseFloat(this.pushtoCart.base_price) + parseFloat(modifierPrice);
				// var netTotal = totalPricePer * this.pushtoCart.item_qty;

				// now need to calculate price depending on selected modifier
				this.cartItem.push({
					item_id: this.currentSelectedMenu.object.id,
					item_qty: this.pushtoCart.item_qty,
					name: this.currentSelectedMenu.object.name,
					actual_price: this.currentSelectedMenu.price_calculation,
					base_price: this.pushtoCart.base_price,
					note: this.pushtoCart.note,
					modifiers: this.pushtoCart.modifiersOrdered
				});

				// now set local storage
				// localStorage.setItem("cartitem", JSON.stringify(this.cartItem));

				// Now free sections
				this.freeCartSection();
			},

			freeCartSection() {
				this.currentSelectedMenu = {
					selected: false,
					object: []
				};
				this.pushtoCart = {
					item_qty: 1,
					base_price: 0,
					actual_price: 0,
					note: "",
					modifiers: []
				};
			},

			decQty() {
				if (this.pushtoCart.item_qty > 1) {
					this.pushtoCart.item_qty = this.pushtoCart.item_qty - 1;
				}
			},

			incQty() {
				this.pushtoCart.item_qty = this.pushtoCart.item_qty + 1;
			},

			backToMenuList() {
				this.backFromCheckout();
				this.currentSelectedMenu.selected = false;
				this.currentSelectedMenu.object = [];
				this.freeCartSection();
			},

			showmMenuItemDetail(obj) {
				// will append data to obj
				this.getItemDetail(obj.id);
				this.currentSelectedMenu.selected = true;
				// product  initial price
				this.pushtoCart.base_price = obj.price;
			},

			selectOrderLaterHour(obj) {
				this.chooseTime.orderLater.selectedHour = obj;
				this.chooseTime.active = false;
				this.chooseMethods.active = true;
			},

			focusOrderLaterHour(key) {
				this.chooseTime.orderLater.availableHours[key].focus = true;
				for (var hourKey in this.chooseTime.orderLater.availableHours) {
					if (hourKey != key) {
						this.chooseTime.orderLater.availableHours[hourKey].focus = false;
					}
				}
			},

			selectOrderLaterDay(key, obj) {
				console.log(key, obj)
				this.chooseTime.orderLater.days[key].selected = true;
				// make other selected false
				for (var key2 in this.chooseTime.orderLater.days) {
					if (key != key2) {
						this.chooseTime.orderLater.days[key2].selected = false;
					}
				}
				this.chooseTime.orderLater.selectedDate = obj;
				this.getAvailableHours(obj);
			},

			getAvailableHours(obj) {
				if (this.locations.selected.location_hours[obj.indexofWeek]) {
					var openingTime = this.locations.selected.location_hours[
						obj.indexofWeek
						].open_time;
					var closeTime = this.locations.selected.location_hours[obj.indexofWeek]
						.close_time;
					var openExp = openingTime.split(":");
					var closeExp = closeTime.split(":");

					var openingDayTime = new Date(
						obj.year,
						obj.month,
						obj.date,
						openExp[0],
						openExp[1],
						openExp[2]
					);
					var openStr = openingDayTime.getTime();
					moment(openingDayTime)

					var closingdayTime = new Date(
						obj.year,
						obj.month,
						obj.date,
						closeExp[0],
						closeExp[1],
						closeExp[2]
					);
					var closeStr = closingdayTime.getTime(); //moment(closingdayTime).valueOf()

					var differenceInMili = closeStr - openStr;
					var differenceInSec = Math.ceil(differenceInMili / 1000);
					var differenceInMin = Math.ceil(differenceInSec / 60);
					differenceInMin = differenceInMin; // before 30 min of closing time
					var gap = 15; // minutes
					var totalLoop = Math.ceil(differenceInMin / gap);

					var arr = {};
					var start = 0;
					for (var i = 0; i < totalLoop; i++) {
						start += gap;
						arr[i] = {
							hour: moment(openStr)
								.minute(start)
								.format("hh"),
							min: moment(openStr)
								.minute(start)
								.format("mm"),
							ampm: moment(openStr)
								.minute(start)
								.format("a"),
							focus: false,
							global_hour: moment(openStr)
								.minute(start)
								.format("HH:mm:ss")
						};
					}
					this.chooseTime.orderLater.availableHours = arr;
				}
			},
			getFutureSevenDays() {
				var now = new Date();
				var days = {};
				// Now get 7 days from today
				for (var i = 0; i <= 6; i++) {
					var day = moment()
						.add(i, "day")
						.format("ddd");
					var dayFull = moment()
						.add(i, "day")
						.format("dddd");
					var date = moment()
						.add(i, "day")
						.format("DD");
					var fullDate = moment()
						.add(i, "day")
						.format("YYYY-MM-DD");

					days[fullDate] = {
						selected: false,
						day: day,
						dayFull: dayFull,
						date: date,
						fullDate: fullDate,
						year: moment()
							.add(i, "day")
							.format("Y"),
						month: moment()
							.add(i, "day")
							.format("MM"),
						indexofWeek: moment()
							.add(i, "day")
							.weekday()
					};
				}
				this.chooseTime.orderLater.days = days;
			},
			editSection(type) {
				if (type == "locations") {
					this.chooseTime.active = false;
					this.chooseTime.selected = "";
					this.chooseMethods.active = false;
					this.chooseMethods.selected = "";
					this.locations.active = true;
					this.menuItems.active = false;
					this.chooseTime.orderLater.active = false;
					this.chooseTime.orderLater.availableHours = false;
					this.chooseTime.orderLater.selectedDate = {};
					this.chooseTime.orderLater.selectedHour = {};
					// if anyslected in days remove it
					for (var key in this.chooseTime.orderLater.days) {
						this.chooseTime.orderLater.days[key].selected = false;
					}
				} else if (type == "time") {
					if (this.chooseMethods.active || this.menuItems.active) {
						this.chooseMethods.active = false;
						this.chooseMethods.selected = "";
						this.chooseTime.active = true;
					}
				} else if (type == "method") {
					if (this.menuItems.active) {
						this.menuItems.active = false;
						this.chooseMethods.active = true;
					}
				}
			},
			selectSection(type, obj) {
				if (type == "location") {
					this.locations.selected = obj;
					if (this.locations.selected.location_profile === null) {
						alert(
							"This location is not ready to order yet, please come back later"
						);
						return false;
					} else if (this.locations.selected.location_hours.length === 0) {
						alert(
							"this location is not ready to order yet, please come back later"
						);
						return false;
					} else {
						this.locations.active = false;
						this.chooseTime.active = true;
						if (obj.id) {
							// right now 115- id only available so hard coded
							this.getMenuCategory(obj.id);

							// right now 70- id only available so hard coded
							// this.getMenuCategory(obj.id)
						}
						// set delivery
						if (
							this.locations.selected.delivery === 1 &&
							this.locations.selected.current_delivery_status === 1 &&
							this.locations.selected.current_online_ordering_status === 1 &&
							this.locations.selected.location_profile.delivery_radius > 0
						) {
							this.locations.delivery_status = true;
						}
						// auto selecting order now if only enable_pickup_later = 0, else multiple case
						if (!this.isEnablePickupLater) {
							this.selectSection("time", this.chooseTime.data[0]);
						}
					}
				} else if (type == "time") {
					// If order is for now check the status
					if (obj.identifier == "now") {
						if (
							!this.locations.selected.current_online_ordering_status &&
							!this.locations.selected.online_ordering
						) {
							this.chooseTime.orderNowOpenSchedule = this.locations.selected.location_hours;
							this.chooseTime.orderNowAvailable = true;
							this.chooseTime.selected = obj;
							return false;
						}
					}

					if (obj.identifier == "later") {
						this.chooseTime.orderLater.active = true;
						this.chooseTime.selected = obj;
						// AUTO select the current day
						// console.log(this.chooseTime.orderLater.days[Object.keys(this.chooseTime.orderLater.days)[0]])
						this.selectOrderLaterDay(
							Object.keys(this.chooseTime.orderLater.days)[0],
							this.chooseTime.orderLater.days[
								Object.keys(this.chooseTime.orderLater.days)[0]
								]
						);
						return false;
					}

					this.chooseTime.selected = obj;
					this.chooseTime.active = false;
					this.chooseMethods.active = true;

					// IF delivery is NOT available, then automatically select the ‘pickup’ option and remove the ‘edit’ icon
					if (!this.locations.delivery_status) {
						this.selectSection("method", this.chooseMethods.data[0]);
					}
				} else if (type == "method") {
					this.chooseMethods.selected = obj;
					this.chooseMethods.active = false;
					this.menuItems.active = true;
				}
			},

			backFromCheckout() {
				$(".main-cat-list")
					.parent()
					.find(".sub-cat-ul")
					.slideUp();
				$(".sub-cat-list")
					.parent()
					.siblings()
					.find(".sub-sub-cat-ul")
					.slideUp();
				this.checkout.form = false;
				this.loginForm.direct = false;
				this.enableCheckoutForm("setback");
			},

			gotoCheckout() {
				if (this.cartItem.length > 0) {
					var self = this
					this.checkout.form = true;
					this.cartItemToggle = false; // if is mobile and showing cart overlay hide it
					//  NOTE: hide login for now
					this.checkout.formType.guestCheckout = true;
					// this.$nextTick(function() {
					//   console.log('a')
					//   document.getElementsByClassName('autocomplete__inputs')[0].children[0].addEventListener('input', function(){
					//     let input = document.getElementsByClassName('autocomplete__inputs')[0].children[0].value
					//     let url = "https://ecomm.api.unoapp.io/api/app/locations/googlelocation/" + input
					//     self.axios.get(url)
					//       .then(success => {
					//         self.autoCompleteDataSource = success.data
					//         console.log(success.data)
					//       })
					//       .catch(error => {
					//         self.autoCompleteDataSource.push({})
					//       });
					//   })
					// });
					this.locations.selected.location_profile.gateway_name === "bambora"
					if (this.locations.selected.location_profile.gateway_name === "stripe" && this.stripe.library === '') {
						this.stripe.enabled = true;
						this.$nextTick(function() {
							importer.url("https://js.stripe.com/v3/").then(() => {
								this.stripeInit();
							});
						});
					}
					else if(this.locations.selected.location_profile.gateway_name === "cayan") {
						this.cayan.enabled = true;
					} else if(this.locations.selected.location_profile.gateway_name === 'bambora') {
						this.bambora.enabled = true;
					} else if (this.locations.selected.location_profile.gateway_name === 'payeezy') {
						this.payeezy.enabled = true;
						window.Payeezy = Payeezy
					}

					//  if( this.isUserLoggedIn()) {

					//     this.checkout.formType.guestCheckout = true

					//  } else {

					//     this.enableCheckoutForm('mainForm')
					//  }
				} else {
					alert(
						"Your cart is empty. Add something to your cart before checking out."
					);
				}
			},

			selectSectionss(i, section) {
				// ?
				this.selectedSection[i] = section;
				this.nextSection();
			},

			nextSection() {
				this.activeSection++;
			},

			reset() {
				this.selectedSection = [null, null, null];
				this.activeSection = 0;
				this.step = 0;
				this.numOfRequire = 0;
				this.freeCartSection();
				// reset everyting
				this.loginForm.direct = false;
				this.checkout.form = false;
				this.checkout.formType.mainForm = false;
				this.checkout.formType.thankyou = false

				this.cartItem = [];
			},

			removeCartItem(index) {
				this.cartItem.splice(index, 1);
				this.$forceUpdate();
				// if cart doesnot have item then get back to menu items
				if (this.cartItem.length < 1) {
					this.backFromCheckout();
				}
			},
			isNumber: function (evt) {
				evt = (evt) || window.event
				var charCode = (evt.which) ? evt.which : evt.keyCode
				if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 || this.contact.phone.length>=10) {
					evt.preventDefault()
				} else {
					return true
				}
			},

			addItem(item) {
				this.itemList.push(item);
				this.$forceUpdate();
			},

			isHalfHourLater(timeString) {
				// NOTE: only checks TODAY, 24 HH format
				let firstIndexOfDay = this.chooseTime.orderLater.selectedDate.indexofWeek;
				let today = this.locations.selected.location_hours[firstIndexOfDay]
				// if store is closed..show no timings
				if(today.open === 0) {
					return false;
				}
				// store open time + 30 mins
				let store_open_time = moment(this.locations.selected.location_hours[firstIndexOfDay].open_time, "HH:mm:ss")
					.add(0, 'seconds')
					.add(30, 'minutes')
					.format('HH:mm:ss');
				// store close time + 30 mins
				let store_close_time = moment(this.locations.selected.location_hours[firstIndexOfDay].close_time, "HH:mm:ss")
					.add(0, 'seconds')
					.add(-30, 'minutes')
					.format('HH:mm:ss');
				// hide time if < opentime+ 30min OR > closetime - 30min
				if (store_open_time>timeString || timeString> store_close_time) {
					return false
				}

				if (moment().day() == firstIndexOfDay) {
					let future = moment(
						moment()
							.add(30, "minutes")
							.format("HH:mm:ss"),
						"HH:mm:ss"
					);
					// console.log(future)
					let timeLi = moment(timeString, "HH:mm:ss");
					// console.log(future)
					// console.log(future.isBefore(timeLi))
					return future.isBefore(timeLi);
				} else {
					return true;
				}
			}
		},
		computed: {
			grandtotal() {
				var grandTotal = parseFloat(this.total) + parseFloat(this.tip.amount) - parseFloat(this.promoTotal);
				if(this.chooseMethods.selected.title=="Delivery"){
					grandTotal+= parseFloat(this.deliveryCharges)
					return grandTotal.toFixed(2);
				}
				return grandTotal.toFixed(2);
			},
			deliveryCharges (){
				if(this.chooseMethods.selected.title=="Delivery"){
					var delivery = parseFloat(this.delivery.deliveryCharges)
					return delivery.toFixed(2)
				}
			},
			total() {
				var total = parseFloat(this.subtotal) + parseFloat(this.tax)
				return total.toFixed(2);
			},
			tax() {
				var taxRate = this.locations.selected.location_profile.tax;
				var taxPercent = (taxRate / 100).toFixed(2);
				return (this.subtotal * taxPercent).toFixed(2);
			},
			subtotal() {
				var subtotal = this.cartItem.reduce((t, x) => {
					t += x.actual_price * x.item_qty;
					return t;
				}, 0);
				return subtotal.toFixed(2);
			},
			promoTotal(){
				var total = 0;
				for(let x = 0 ; x < this.promoCode.discountApplied.length ; x++){
					total += parseFloat(this.promoCode.discountApplied[x])
				}
				return total.toFixed(2)
			},
			isEnablePickupLater() {
				if (this.locations.selected && this.locations.selected.location_profile) {
					if (this.locations.selected.location_profile.enable_pickup_later) {
						return true;
					} else {
						return false;
					}
				} else {
					return true;
				}
			},
			formattedPhoneNumber() {
				var s2 = (""+this.locations.selected.phone).replace(/\D/g, '');
				var m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
				return (!m) ? null : "(" + m[1] + ") " + m[2] + "-" + m[3];
			},
			checkStoreStatus () {
				if(this.chooseTime.orderLater.active) {
					// selected time
					var selectedTime = this.chooseTime.orderLater.selectedHour.global_hour;
					var date = moment(this.chooseTime.orderLater.selectedDate.fullDate)
					// day of week of selected Time
					var dow = this.locations.selected.location_hours[date.day()]
					return selectedTime>dow.open_time && selectedTime<dow.close_time && dow.open ===1
				}
				let d = new Date();
				let today = this.locations.selected.location_hours[d.getDay()]
				let currentTime = d.getHours()+ ":" + d.getMinutes() + ":" +d.getSeconds()
				let openTime = moment(today.open_time, 'HH:mm:ss')
				let closeTime = moment(today.close_time, 'HH:mm:ss')
				currentTime = moment(currentTime, 'HH:mm:ss')
				return currentTime.isBefore(closeTime) && currentTime.isAfter(openTime)
			},
			subtotalIncTax () {
				let subtotal_tax = parseFloat(this.subtotal) + parseFloat(this.tax)
				return subtotal_tax.toFixed(2)
			}
		}
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import url("https://fonts.googleapis.com/css?family=Oswald:300,400,500,600,700");
  body,
  p,
  li,
  td {
    font-family: "Oswald", sans-serif;
    font-weight: 300;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 600;
    font-family: "Oswald", sans-serif;
  }



  .show-scroller {
    overflow: hidden;
    overflow-y: scroll;
    height: 70vh;
  }
  .menu-items {
  }
  .menu-title {
    border-bottom: 1px solid rgba(0, 0, 0, 0.3);
    padding-left: 20px;
    font-size: 24px;
    padding-bottom: 10px;
    font-weight: bold;
  }
  .fl-right {
    float: right;
  }
  .text-right {
    text-align: right;
  }
  .bold {
    /*font-weight: bold;*/
  }
  .pad-10 {
    padding: 10px;
  }
  .pad-20 {
    padding: 20px;
  }
  .pad-30 {
    padding: 30px;
  }
  .text-left {
    text-align: left;
  }
  .top-border {
    border-top: 1px solid rgba(0, 0, 0, 0.3);
  }
  .btm-border {
    border-bottom: 1px solid rgba(0, 0, 0, 0.3);
  }
  .flex {
    display: flex;
  }
  .accent {
    color: cornflowerblue;
  }
  .accent-bg {
    background-color: cornflowerblue;
  }
  .animate {
    transition: all 0.1s;
  }
  .hover:hover {
    cursor: pointer;
  }
  .select:hover {
    background-color: #efefef;
  }
  .sectionBody {
    overflow: auto;
  }
  .flex-column {
    flex-direction: column;
  }
  .item-start {
    align-items: flex-start !important;
  }
  .content-center {
    justify-content: center !important;
  }
  .content-start {
    justify-content: flex-start !important;
  }
  .flex-center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .normalText {
    font-size: 18px;
  }
  .activeBody {
    text-align: left;
    padding: 12px 15px 12px 50px;
    background: white;
    border-bottom: 1px solid #dadada;
    color: black;
    font-size: 18px;
  }
  .inactiveTitle {
    text-align: left;
    padding: 15px 15px 15px 0px;
    background: white;
    border-bottom: 1px solid #dadada;
    color: black;
    font-size: 24px;
  }
  .activeTitle {
    text-align: left;
    padding: 15px 15px 15px 0px;
    background: #4c555d;
    border-bottom: 1px solid #dadada;
    color: white;
    font-size: 24px;
  }
  .whiteBg {
    background-color: white;
    width: 550px;
    height: 100vh;
  }
  .smallWhiteBg {
    background-color: #f2f2f2;
    border-left: 1px solid rgba(0, 0, 0, 0.3);
    width: 250px;
    height: 100vh;
  }

  .greyBg {
    background-color: #f2f2f2;
  }
  .darkBg {
    background-color: rgba(0, 0, 0, 0.8);
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
  }
  h1,
  h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }

  /** Spinner **/

  .loader,
  .loader:before,
  .loader:after {
    background: #ccc;
    -webkit-animation: load1 1s infinite ease-in-out;
    animation: load1 1s infinite ease-in-out;
    width: 1em;
    height: 4em;
  }
  .loader {
    color: #ccc;
    text-indent: -9999em;
    margin: 88px auto;
    position: relative;
    font-size: 11px;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
  }
  .loader:before,
  .loader:after {
    position: absolute;
    top: 0;
    content: "";
  }
  .loader:before {
    left: -1.5em;
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
  }
  .loader:after {
    left: 1.5em;
  }
  @-webkit-keyframes load1 {
    0%,
    80%,
    100% {
      box-shadow: 0 0;
      height: 4em;
    }
    40% {
      box-shadow: 0 -2em;
      height: 5em;
    }
  }
  @keyframes load1 {
    0%,
    80%,
    100% {
      box-shadow: 0 0;
      height: 4em;
    }
    40% {
      box-shadow: 0 -2em;
      height: 5em;
    }
  }

  .is-active.accordion__pane-header {
    background: #4c555d;
    border-bottom: 1px solid #dadada;
    color: #fff;
  }
  .accordion__pane-header {
    webkit-transition: all 0.1s ease-out;
    transition: all 0.1s ease-out;
    background: #f2f2f2;
    border-bottom: 1px solid #dadada;
    color: #4c555d;
    padding: 15px 30px 15px 50px;
    position: relative;
  }
  .tab-heading-icon {
    margin-right: 15px;
  }

  .cartTotal {
    overflow:auto;
    height:calc(92vh - 135px - 20px - 100px - 90px)
  }
  .bottom-fixed{
    position: fixed;
    bottom: 5px;
    width: 245px;
    padding-right: 5px;

  }

  .cartItems {
    overflow-y: scroll;
    margin-bottom:30%;
  }

  @media not all and (min-resolution:.001dpcm) { @media {
    .cartTotal {
      overflow:auto;
      height:calc(92vh - 135px - 20px - 70px - 160px)
    }
    @media only screen and (max-width: 470px) {
      .cartTotal {
        height:calc(92vh - 135px - 20px - 50px - 100px);
        position:relative;
      }
    }
  }
  }

  .safari-no-padding {
    padding: 0 0 0 0;
  }

  .popup-wrap {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    background: rgba(0, 0, 0, 0.5098039215686274);
  }
  .popup-content {
    left: 50px;
    width: 30%;
    background: #fff;
    text-align: left;
    padding: 40px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  .popup-wrap table {
    border-collapse: collapse;
  }
  .popup-wrap table td {
    font-size: 13px;
    padding: 8px;
    border-bottom: 1px solid #ccc;
  }
  .popup-wrap table tr td:first-child {
    width: 100px;
  }
  .popup-wrap table tr:nth-child(odd) td {
    background: #fafafa;
  }

  .popup-wrap table tr:nth-child(even) td {
    background: #fff;
  }
  .popup-btn-wrapper {
    text-align: right;
    margin-top: 30px;
  }
  .primary-btn {
    background: #3288e6;
    color: #fff;
    cursor: pointer;
    border: none;
    padding: 10px;
    width: 100px;
  }
  .popup-wrap h3,
  .popup-wrap h4 {
    font-weight: 300;
  }
  .order-later-header {
    position: relative;
    background: #f2f2f2;
    text-align: left;
    padding: 20px 45px;
  }
  .order-later-header h4 {
    padding-right: 40px;
    color: #000;
    font-weight: 400;
    position: relative;
  }
  .order-later-header h4 a {
    position: absolute;
    right: 0;
    top: 0px;
    color: #3498db;
    text-decoration: none;
  }
  .order-later-header ul li {
    font-family: "Oswald", sans-serif;
    font-weight: 400;
    margin: 0;
    cursor: pointer;
    padding: 10px 18px;
    text-align: center;
  }
  .order-later-header ul li.active,
  .order-later-header ul li:hover {
    background: #439ddc;
    color: #fff;
  }

  .order-later-header ul li span {
    display: block;
  }
  .order-later-content {
    min-height: 200px;
    position: relative;
  }
  .order-later-content .note {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    margin-right: 0 auto;
    transform: translateY(-50%);
    font-family: "Oswald", sans-serif;
    font-weight: 300;
  }
  .relative {
    position: relative;
  }
  .order-later {
    position: absolute;
    top: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
  }
  .order-later-content ul {
    margin-top: 0;
  }
  .order-later-content ul li {
    display: block;
    border-bottom: 1px solid #f3f3f3;
    cursor: pointer;
  }
  .order-later-content ul li:hover {
    background-color: #fafafa;
  }
  .order-later-content ul li p {
    padding: 10px;
    margin: 0;
  }
  .order-later-content ul li a {
    display: block;
    text-decoration: none;
    padding: 10px;
  }
  .order-later-content ul li.active {
    background-color: #439ddc;
    color: #fff;
  }
  .order-later-content ul li.active a {
    color: #fff;
  }
  .order-later-content ul li.active:hover {
    background-color: #2d83bf;
  }
  .secected-location-overview {
    font-size: 12px;
    font-family: "Oswald", sans-serif;
  }
  .secected-time-overview {
    font-weight: 400;
    font-size: 18px;
    font-family: "Oswald", sans-serif;
  }

  .main-cat-list h4 {
    text-align: left;
    font-weight: 400;
    padding-right: 55px;
    position: relative;
    border-bottom: 1px solid #dadada;
    margin: 0;
    padding: 10px 0;
  }
  .main-cat-list h4:hover {
    background-color: #fafafa;
    cursor: pointer;
  }
  .pointer {
    cursor: pointer;
  }
  .main-cat-list h4 .fa {
    position: absolute;
    right: 0;
    top: 19px;
  }
  .menu-items-wrapper ul {
    padding-left: 10px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  .menu-items-wrapper ul li {
    display: block;
    text-align: left;
    color: #333;
    border-bottom: 1px solid #dadbda;
  }
  .menu-items-wrapper ul li a {
    color: #333;
    text-decoration: none;
    padding: 10px 0;
    display: block;
  }
  .sub-cat-list,
  .sub-sub-cat-list {
    padding: 8px 0;
    margin-bottom: 0;
    font-weight: 400;
  }
  ul.sub-sub-cat-ul li:first-child {
    border-top: 1px solid #ccc;
  }
  .sub-cat-list:hover {
    background-color: #fafafa;
  }
  .menu-items-wrapper {
    height: 90%;
    overflow: hidden;
    overflow-y: scroll;
  }

  /* Cayan Errors */

  @media only screen and (max-width: 400px) {
    .show-scroller {
      overflow: hidden;
      overflow-y: scroll;
      height: 60vh;
    }
    .menu-items-wrapper {
      height: 80%;
      overflow: hidden;
      overflow-y: scroll;
      margin-top:8%;
    }

  }
  .menu-items-wrapper ul li ul li:last-child {
    border: none;
  }
  .menu-items-wrapper ul li a span {
    float: right;
    font-weight: 400;
  }
  .menu-item-detail {
    text-align: left;
    padding-bottom: 10px;
  }
  .menu-item-detail h3 {
    position: relative;
    padding-right: 70px;
  }
  .menu-item-detail h3 span {
    position: absolute;
    top: 0;
    right: 0;
  }
  .menu-item-detail p {
    margin-top: 0px;
  }
  button.btn.quantity__minus,
  button.btn.quantity__plus {
    font-size: 23px;
    border: none;
    width: 32px;
    text-align: center;
    background: #f9f7f7;
    cursor: pointer;
  }
  button.btn.quantity__minus:active,
  button.btn.quantity__plus:active {
    outline: none;
  }
  button.btn.quantity__minus:hover,
  button.btn.quantity__plus:hover {
    background: #e6e6e6;
  }
  button.btn.quantity__minus {
    border-right: 1px solid #ccc;
  }
  button.btn.quantity__plus {
    border-left: 1px solid #ccc;
  }
  span.num-quantity.text--center {
    font-size: 13px;
    width: 28px;
    display: inline-block;
    text-align: center;
    position: relative;
    top: -2px;
  }
  .quantity-selector {
    display: inline-block;
    border: 1px solid #ccc;
  }
  .special-instruction-wrapper {
    clear: both;
    display: block;
    margin-top: 25px;
  }
  .special-instruction-wrapper label {
    display: block;
  }
  .special-instruction-wrapper textarea {
    width: 100%;
    height: 50px;
    border: 1px solid #ccc;
    margin-top: 5px;
    padding: 0;
    margin-bottom: 10px;
    font-size:16px;
  }
  .cart-item-list {
    font-family: "Oswald", sans-serif;
    font-size: 13px;
    font-weight: 400;
    border-bottom: 1px solid #ccc;
    position: relative;
  }
  .fa.fa-times.remove-item {
    position: absolute;
    top: 15px;
    right: 5px;
    color: red;
  }
  .fa.fa-times.remove-item:hover {
    color: #ab0000;
  }
  .cart-item-list .fl-right {
    margin-right: 20px;
  }
  .modifiers-wrapper {
    margin-top: 30px;
    margin-bottom: 30px;
    display: inline-block;
  }
  .modifiers-wrapper ul {
    padding-left: 0;
  }
  .modifiers-wrapper ul li {
    border: none;
    margin: 0;
    margin-bottom: 8px;
    font-family: "Oswald", sans-serif;
    font-size: 13px;
  }
  .modifiers-wrapper ul li input {
    margin-right: 8px;
  }
  .cart-item-modifiers li {
    display: block;
  }

  /** checkout form **/
  section.checkout-login-form-wrapper h2 {
    border-bottom: 1px solid #f1f1f1;
    padding-bottom: 15px;
    font-size: 35px;
    color: #409eff;
    margin-top: 0px;
    text-align: center;
  }
  button.login-with-gmail {
    width: 100%;
    padding: 15px;
    border: 1px solid #f1f1f1;
  }
  /*section.checkout-login-form-wrapper .fa {
font-size: 25px;
border-right: 1px solid #f1f1f1;
padding-right: 14px;
float: left;
}*/
  section.checkout-login-form-wrapper span {
    font-size: 16px;
    position: relative;
    line-height: 23px;
  }
  button.login-with-gmail:hover {
    color: #212121;
    background-color: #f1f1f1;
    border-color: #dcdbdb;
    transition: all 0.4s ease-out;
    -moz-transition: all 0.4s ease-out;
  }
  .checkout-login-form {
    display: inline-block;
    width: 100%;
    margin-top: 45px;
    margin-bottom: 40px;
  }
  .checkout-login-form input {
    height: 25px;
    margin-bottom: 9px;
    padding: 10px;
    font-size: 16px;
    float: left;
    width: 95%;
    background-color: #f5f5f5;
    border: none;
  }
  .checkout-login-form .submit-login {
    font-size: 16px;
    float: left;
    width: 99%;
    padding: 15px;
    margin-bottom: 10px;
    color: #fff;
    border: 1px solid #1781ef;
    background: #409eff;
    cursor: pointer;
    font-family: "Oswald", sans-serif;
  }
  .checkout-login-form .submit-login:hover {
    background: #1781ef;
  }
  .checkout-form-attrs {
    display: inline-block;
    width: 100%;
    margin-bottom: 25px;
  }
  .checkout-form-attrs a.checkout-form-cancel {
    float: left;
    text-decoration: none;
    color: #409eff;
  }
  a.checkout-form-cancel-btn {
    float: left;
    text-decoration: none;
    width: 100% !important;
    background: #409eff !important;
    color: #fff !important;
    border-radius: 0px !important;
    font-size: 24px !important;
    margin-top: 10px !important;
    padding: 4px 0 !important;
    text-align: center !important;
  }
  .checkout-form-attrs a.checkout-form-forgot-pass {
    float: right;
    text-decoration: none;
    color: #409eff;
    margin-right: 5px;
  }
  .checkout-form-attrs a.checkout-form-cancel:hover,
  .checkout-form-attrs a.checkout-form-forgot-pass:hover {
    color: #333;
  }
  .guest-checkout-wrapper a {
    display: block;
    border: 1px solid #42b983;
    color: #fff;
    text-decoration: none;
    padding: 15px;
    width: 92%;
    background: #56923c;
    font-family: "Oswald", sans-serif;
  }
  .guest-checkout-wrapper a:hover {
    background: #3c6b26;
    border: 1px solid #3c6b26;
    color: #ffffff;
  }
  .guest-checkout-wrapper {
    margin-top: 45px;
  }
  label.modifier-heading {
    font-weight: 400;
    margin-bottom: 5px;
    display: block;
  }

  /*** list-item dispaly change ***/

  ul.modifier-items {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    justify-content: space-between;
  }

  ul.modifier-items div {
    flex-basis: 50%;
  }
  @media only screen and (max-width: 768px) {
    ul.modifier-items div {
      flex-basis: 100%;
    }
  }

  ul.cart-modifier-cat-items {
    padding: 0;
    margin: 0;
  }

  ul.cart-modifier-cat-items li {
    padding: 0;
    margin: 0;
    margin-bottom: 5px;
    display: inline-block;
    width: 100%;
  }
  ul.cart-modifier-cat-items li span {
    float: right;
  }
  .guest-checkout-wrapper.create-an-account-wrapper {
    margin-bottom: 12px;
  }

  .guest-checkout-wrapper.create-an-account-wrapper a {
    border: 1px solid #333;
    background-color: #333;
    color: #fff;
  }
  .guest-checkout-wrapper.create-an-account-wrapper a:hover {
    border: 1px solid #585757;
    background-color: #585757;
  }
  .form-checkbox {
    text-align: left;
    font-weight: 300;
    position: relative;
    padding-left: 25px;
    float: left;
    width: 100%;
    margin-bottom: 5px;
    margin-top: 5px;
  }
  .form-checkbox input {
    width: auto;
    float: none;
    position: absolute;
    left: -5px;
    top: -2px;
  }
  .registration-wrapper {
    text-align: left;
  }
  .registration-wrapper h2 {
    text-align: center;
  }
  button.submit-login.submit-register {
    margin-top: 25px;
  }
  .invisible {
    position: absolute;
    visibility: hidden;
    opacity: 0;
    transition: 0.4s ease-in-out;
    left: -1500px;
  }
  .visible {
    position: relative;
    visibility: visible;
    opacity: 1;
    transition: 0.4s ease-in-out;
    left: 0;
  }
  p.alert.alert-warning {
    background: #f30000;
    color: #fff;
    padding: 5px;
    width: 97%;
  }
  .checkout-overview {
    text-align: left;
  }
  .checkout-overview section {
    background: #f9f9f9;
    margin-bottom: 15px;
  }
  .checkout-overview section h4 {
    background: #ececec;
    padding: 5px 10px;
    font-weight: 400;
    margin: 0;
  }
  .checkout-overview .section-content {
    padding: 12px;
  }
  .checkout-overview .section-content p {
    font-size: 14px;
    display: inline-block;
    width: 100%;
  }
  .section-content input,
  .section-content select {
    font-size: 14px;
    padding: 4px;
  }

  .section-content input,
  .section-content select {
    font-size: 14px;
  }
  .checkout-order-details p {
    margin: 0px;
    font-weight: 300;
  }
  .checkout-order-details p:first-child {
    font-weight: 400;
  }
  .checkout-user-info p {
    position: relative;
    display: inline-block;
    width: 100%;
    margin: 5px 0;
  }
  .checkout-user-info p label {
    width: 60px;
    float: left;
    margin-right: 10px;
    position: relative;
    top: 4px;
  }
  .checkout-user-info p input {
    width: calc(100% - 82px);
    float: left;
  }
  .checkout-user-info p textarea {
    border: 1px solid #ccc;
    width: calc(100% - 76px);
    float: left;
    font-size: 13px;
  }
  .checkout-order-details p strong {
    font-weight: 400;
  }
  input.card-no {
    float: left;
    width: 200px;
    margin-right: 15px;
    border: 1px solid rgb(166, 166, 166);
  }
  .card-no {
    float: left;
    width: 200px;
    margin: 5px 15px 5px 0;
    border: 1px solid rgb(166, 166, 166);
    background: #fff;
    padding:2px 2px 2px 8px;
  }

  .bamboraExpiry {
    float: left;
    width: 87.5%;
    margin: 5px 15px 5px 0;
    border: 1px solid rgb(166, 166, 166);
    background: #fff;
    padding:2px 2px 2px 8px;
  }

  .cvv {
    float: left;
    width: calc(100% - 239px);
    border: 1px solid rgb(166, 166, 166);
    padding:2px 2px 2px 8px;
  }

  input.cvv {
    float: left;
    width: calc(100% - 239px);
    border: 1px solid rgb(166, 166, 166);
  }
  select.card-exp-month {
    float: left;
    width: 212px !important;
    margin-right: 15px;
    border: 1px solid rgb(166, 166, 166);
  }
  select.card-exp-year {
    width: calc(100% - 227px);
    float: left;
    border: 1px solid rgb(166, 166, 166);
  }
  p.card-detail {
    margin-top: 15px !important;
  }
  select.card-exp-month {
    width: calc(100% - 239px);
    float: left;
    border: 1px solid rgb(166, 166, 166);
  }

  .card-dates select {
    background-color: #fff;
    height: 34px;
  }
  .checkout-payment-details p {
    margin: 5px 0;
  }
  .checkout-order-summary ul {
    padding-left: 0px;
  }
  .checkout-order-summary ul li {
    border-bottom: none;
    padding-left: 0px;
    border-bottom: none;
    display: inline-block;
    width: 100%;
    margin-left: 0px;
  }
  .checkout-order-summary ul li span {
    float: right;
  }
  .checkout-tip ul {
    padding-left: 0px;
    display: inline-block;
    margin-bottom: 0;
    width: 100%;
  }
  .checkout-tip ul li {
    margin-left: 0;
    border: none;
    float: left;
    width: 55px;
    margin: 0;
    margin-right: 8px;
  }
  .checkout-tip ul li:last-child {
    width: calc(100% - 260px);
    float: left;
    margin-right: 0;
  }
  li.display-tip-price input {
    width: 100%;
    background: #fff;
    display: block !important;
    height: 16px;
  }
  .checkout-tip ul li input {
    display: none;
  }
  .checkout-tip ul li label {
    background-color: #ffffff;
    border: 1px solid #ccc;
    padding: 3px 10px;
    font-size: 13px;
    cursor: pointer;
    display: block;
    text-align: center;
  }
  .checkout-tip ul li input[type="radio"]:checked + label {
    background: #409eff;
    border: #409eff;
    color: #fff;
  }
  li.display-tip-price span {
    border: 1px solid #ccc;
    display: block;
    width: 188px;
    padding: 2px 5px;
    background-color: #fff;
    font-weight: 300;
  }
  p.paylater {
    font-weight: 300;
  }
  a.accent {
    cursor: pointer;
  }
  .user-billing-lists,
  .add-new-billing-address {
    background: #fff;
    padding: 9px;
    margin-bottom: 20px;
    margin-top: 5px;
    border: 1px solid #ececec;
  }
  .add-new-billing-address {
    margin-bottom: 0px;
  }
  .user-billing-lists ul {
    padding-left: 0px;
    margin-left: 0px;
  }
  .user-billing-lists ul li {
    border-bottom: none;
    margin-left: 0px;
    font-weight: 300;
    font-size: 13px;
    margin: 5px 0;
  }
  p.modifier-cat-title {
    margin: 0;
    margin-bottom: 5px;
    font-weight: 400;
  }
  p.validate-message {
    color: #e40000;
    font-weight: 300;
  }

  h4.open .fa-chevron-right {
    transform: rotate(90deg);
  }
  .sub-cat-list .fa,
  .sub-sub-cat-list .fa {
    float: right;
    position: relative;
    top: 4px;
  }
  .sub-cat-list.open .fa,
  .sub-sub-cat-list.open .fa {
    transform: rotate(90deg);
  }
</style>
<style type="text/css">
  img.autocomplete__icon {
    display: none;
  }
  .autocomplete__box.search-address {
    height: 32px;
    border-radius: 0;
  }
  .autocomplete__box.search-address input {
    font-family: "Oswald", sans-serif;
    font-size: 13px;
    font-weight: 300;
  }
  .img-shadow {
    -webkit-box-shadow: -1px -1px 52px -2px rgba(201,199,201,1);
    -moz-box-shadow: -1px -1px 52px -2px rgba(201,199,201,1);
    box-shadow: -1px -1px 52px -2px rgba(201,199,201,1)
  }
  .item-img-header {
    max-height: 250px;
    max-width: 350px;
    margin-left: auto;
    margin-right: auto;
  }

  @media only screen and (max-width: 370px) {
    .item-img-header {
      max-height: 200px;
      max-width: 250px;
    }
  }
  .sub-cat-list .fa,
  .sub-sub-cat-list .fa {
    font-family: FontAwesome !important;
  }
  a.create-account {
    text-decoration: none;
    margin-left: 50px;
  }
  a.create-account .fa {
    float: none !important;
    padding: 0;
    border: none !important;
    padding-right: 5px !important;
    font-size: 19px !important;
  }
  p.special-instructions {
    font-weight: 300;
    padding-left: 10px;
    font-size: 13px;
  }
  .checkoutloading {
    position: absolute;
    z-index: 9;
    background: rgba(255, 255, 255, 0.78);
    width: 100%;
    height: 100%;
  }

  .null-event {
    pointer-events: none !important;
  }
</style>

<style type="text/css">
  .sweet-modal-icon.sweet-modal-warning {
    display: none;
  }
  .sweet-modal {
    width: 100% !important;
    max-width: 800px !important;
  }
  .sweet-modal-overlay {
    width: 100% !important;
    max-width: 800px !important;
    height: 100% !important;
  }
  span.mobile-cart {
    position: absolute;
    top: 0;
    right: 50px;
    top: 17px;
    color: #303030;
    font-size: 18px;
  }
  span.mobile-cart .fa {
    font-size: 25px;
    margin-right: 5px;
    color: #409eff;
  }
  .mobile-cart {
    display: none;
  }

  .mobile-headers {
    display: none;
  }

  @media screen and (max-width: 768px) {
    .mobile-cart {
      display: block;
    }
    .bottom-fixed{
      width: 98% !important;
    }
    .storeClosed{
      font-size: 14px;
    }

    .whiteBg {
      width: 100% !important;
    }
    .whiteBg .fa.fa-pencil {
      position: absolute;
      left: inherit !important;
      right: 50px;
    }
    .smallWhiteBg {
      width: 100% !important;
      position: absolute;
      right: -100%;
      transition: all 0.4s ease-out;
      -moz-transition: all 0.4s ease-out;
      -webkit-transition: all 0.4s ease-out;
    }
    .smallWhiteBg.open {
      right: 0px;
      transition: all 0.4s ease-out;
      -moz-transition: all 0.4s ease-out;
      -webkit-transition: all 0.4s ease-out;
    }
    .mobile-headers {
      display: block;
      margin-top: 10px;
      padding: 10px;
      text-align: left;
    }
    .mobile-headers a {
      color: #409eff;
      text-decoration: none;
    }
  }
  .back-btn {
    margin: 10px;
    padding: 12px 12px;
    text-align: center;
    font-size: 12px;
    min-width: 200px !important;
    white-space: nowrap;
    text-decoration: none !important;
    text-transform: none;
    text-transform: capitalize;
    border: 0 none;
    border-radius: 4px;
    background: #afafaf;
  }
  .back-btn:hover {
    cursor: pointer;
    background: #969696;
  }

  .promoCodeApplied{
    font-weight:400;
    margin-left:3%;
    font-size:17px;
    color:#609dff;
    background-color:#edf4ff;
    padding:2px 10px;
    border: 1px solid #88b6fc;
    border-radius:4px;
    -webkit-box-shadow: 66px 23px 73px -13px rgba(56,54,56,1);
    -moz-box-shadow: 66px 23px 73px -13px rgba(56,54,56,1);
    box-shadow: 66px 23px 73px -13px rgba(56,54,56,1);
    transition: all 0.25s;
  }

  .promoCodeApplied:hover{
    cursor: pointer;
    border: 1px solid #3b69ba;
    background: #dbe8ff;
    color: #3b69ba;
  }

  .promocode input {
    margin-left: 20px;
    margin-right: 20px;
    min-width: 180px;
  }
  .promocode button {
    background-color: #d1d3d6;
    border-radius: 3px;
    border: 1px solid #77787a;
    cursor: pointer;
    font-size: 12px;
    padding: 10px 15px;
    margin-left: auto;
    margin-right: auto;
  }
  .promocode button:hover {
    background-color: #b7b7b7;
  }
  .promocode button:active {
    position: relative;
    top: 1px;
    border-color: #8e8e8e !important;
  }
  .promocode button:focus {
    border-color: #8e8e8e !important;
  }
  @media only screen and (max-width: 460px) {
    .promocode button {
      margin-left: 40%;
      margin-top: 10px;
    }
    .promocode input {
      margin: auto;
      min-width: 95%;
    }
  }

  .storeClosed {
    padding: 10px 20px;
    background: #e0b6b6;
    color: #570101;
    border: 1px solid #c24646;
    font-size: 16px;
    border-radius: 5px;
    text-align: center;
    font-weight: 300;
    letter-spacing: 0.5px;
  }

  .delivery{
    padding: 5px 10px 5px 10px;
    margin: 0 0 5px 0;
  }

  .delivery-error {
    background: #FFD2D2;
    color: #D8000C;
  }

  .delivery-success {
    color: #4F8A10;
    background: #DFF2BF;
  }

  .bamboraErrors {
    color:red;
  }

</style>
<style>
  /* STRIPE CSS */
  .StripeElement {
    background-color: white;
    height: 20px;
    padding: 10px 12px;
    padding-bottom: -10px;
    border-radius: 4px;
    border: 1px solid transparent;
    box-shadow: 0 1px 3px 0 #e6ebf1;
    -webkit-transition: box-shadow 150ms ease;
    transition: box-shadow 150ms ease;
  }

  .StripeElement--focus {
    box-shadow: 0 1px 3px 0 #cfd7df;
  }

  .StripeElement--invalid {
    border-color: #fa755a;
  }

  .StripeElement--webkit-autofill {
    background-color: #fefde5 !important;
  }
  .card-errors {
    margin-left: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/components/MainComponent.vue